import { userWiseRole } from '../../utils/constant'
import {
  entries,
  include,
  isEqual,
  keyForValue,
  notEqual,
  values,
} from '../../utils/javascript'

const {
  admin,
  refurbisher,
  refurbisherUser,
  trader,
  traderUser,
  recycler,
  recyclingTechnician,
  dealer,
  dealerUser,
  nationalGov,
  nationalGovUser,
  spcbGov,
  spcbGovUser,
  districtGov,
  districtGovUser,
  cpcbGov,
  cpcbGovUser,
  consumer,
  consumerUser,
  disposer,
  disposerUser,
  supplier,
  supplierUser,
  producer,
  producerUser,
  dataEntry,
  superUser,
  finance,
  accounts,
  operationsUser,
  scrappingFacilityEntryUser,
  scrappingFacilityManager,
  salesUser,
  categoryUser,
  procurement,
  procurementUser1,
  procurementUser2,
  operations,
  operationsUser1,
  operationsUser2,
  sales: salesUserParent,
  salesUser1,
  salesUser2,
} = userWiseRole

const tabKeys = {
  active: 'active',
  complete: 'complete',
  recovery: 'recovery',
  elv: 'elv',
  testVehicles: 'test-vehicles',
  pcr: 'pcr',
  pir: 'pir',
  shredding: 'shredding',
  pressing: 'pressing',
  smelting: 'material-production',
  recycle: 'recycle',
  dispose: 'dispose',
  sales: 'sales',
  recycleRequest: 'scraping-request',
  smeltingRequest: 'dispatch-recycle-request',
  trader: 'sales',
  supplierProduction: 'part-production',
  forging: 'forging',
  blanking: 'blanking',
  machining: 'machining',
  stamping: 'stamping',
  assembly: 'assembly',
  painting: 'painting',
  materialSalesSupplier: 'material-sales-supplier',
  vehicleProduction: 'vehicle-production',
  materialSalesProducer: 'part-sales-producer',
  vehicleSales: 'vehicle-sales', //producer to dealer
  vehicleSalesConsumer: 'vehicle-sales-consumer', //dealer to consumer
  materialSalesMaterialProducer: 'material-sales-material-producer',
  partSalesPartProducer: 'part-sales-part-producer',
  process: 'process',
  bucketCreation: 'bucket-creation',
  destructionRequest: 'destruction-request',
  reuseRequest: 'reuse-request',
  thirdPartyRecycle: 'recycle-request-new',
  ELVWiseRecycle: 'elv-wise-recycle',
  hydrometallurgy: 'hydrometallurgy',
  sorting: 'sorting',
  pelletizing: 'pelletizing',
  grinding: 'grinding',
  compoundingPelletizing: 'compounding-pelletizing',
  virginMaterialPurchase: 'virgin-material-purchase',
  postProcessing: 'post-processing',
  materialReturn: 'material-return',
}

const {
  active,
  complete,
  recovery,
  elv,
  testVehicles,
  pcr,
  pir,
  smelting,
  recycle,
  sales,
  recycleRequest,
  smeltingRequest,
  supplierProduction,
  forging,
  blanking,
  machining,
  stamping,
  assembly,
  painting,
  materialSalesSupplier,
  vehicleProduction,
  materialSalesProducer,
  vehicleSales,
  vehicleSalesConsumer,
  materialSalesMaterialProducer,
  partSalesPartProducer,
  process,
  bucketCreation,
  destructionRequest,
  reuseRequest,
  thirdPartyRecycle,
  shredding,
  hydrometallurgy,
  sorting,
  grinding,
  pelletizing,
  compoundingPelletizing,
  virginMaterialPurchase,
  postProcessing,
  materialReturn,
} = tabKeys

const jobTabList = {
  status: [
    {
      label: 'txt_Active',
      key: active,
    },
    {
      label: 'job_Complete',
      key: complete,
    },
  ],
  type: [
    {
      label: 'job_Recovery',
      key: recovery,
      permission: [
        admin,
        recycler,
        recyclingTechnician,
        dealer,
        dealerUser,
        nationalGov,
        nationalGovUser,
        spcbGov,
        spcbGovUser,
        districtGov,
        districtGovUser,
        cpcbGov,
        cpcbGovUser,
        consumer,
        consumerUser,
        disposer,
        disposerUser,
        producer,
        producerUser,
        dataEntry,
        superUser,
        finance,
        accounts,
        operationsUser,
        salesUser,
        categoryUser,
        scrappingFacilityManager,
        scrappingFacilityEntryUser,
      ],
      addPermission: [
        recycler,
        scrappingFacilityManager,
        superUser,
        scrappingFacilityEntryUser,
        dataEntry,
        salesUser,
        operationsUser,
        categoryUser,
        dealer,
        dealerUser,
      ],
      subType: [
        {
          label: 'job_ELV',
          key: elv,
        },
        {
          label: 'job_TestVehicles',
          key: testVehicles,
        },
        {
          label: 'job_Pcr',
          key: pcr,
        },
        {
          label: 'job_Pir',
          key: pir,
        },
      ],
    },
    {
      label: 'job_Process',
      key: process,
      permission: [admin],
    },
    {
      label: 'job_BucketCreation',
      key: bucketCreation,
      permission: [admin],
    },
    {
      label: 'home_ScrapProcessingRequest',
      key: recycleRequest,
      permission: [
        admin,
        dealer,
        dealerUser,
        nationalGov,
        nationalGovUser,
        spcbGov,
        spcbGovUser,
        districtGov,
        districtGovUser,
        cpcbGov,
        cpcbGovUser,
        consumer,
        consumerUser,
        disposer,
      ],
    },
    {
      label: 'job_Recycle',
      key: recycle,
      permission: [
        admin,
        // dealer,
        nationalGov,
        nationalGovUser,
        spcbGov,
        spcbGovUser,
        districtGov,
        districtGovUser,
        cpcbGov,
        cpcbGovUser,
        consumer,
        consumerUser,
        disposer,
        disposerUser,
      ],
    },
    {
      label: 'job_3rdPartyRecycleRequest',
      key: thirdPartyRecycle,
      permission: [admin],
    },
    {
      label: 'job_ReuseRequest',
      key: reuseRequest,
      permission: [admin],
    },
    {
      label: 'home_RecycleRequest',
      key: smeltingRequest,
      permission: [
        admin,
        recycler,
        recyclingTechnician,
        dealer,
        dealerUser,
        producer,
        producerUser,
        refurbisher,
        refurbisherUser,
        nationalGov,
        nationalGovUser,
        spcbGov,
        spcbGovUser,
        districtGov,
        districtGovUser,
        cpcbGov,
        cpcbGovUser,
        consumer,
        consumerUser,
        disposer,
        disposerUser,
        dataEntry,
        superUser,
        finance,
        accounts,
        operationsUser,
        scrappingFacilityManager,
        scrappingFacilityEntryUser,
        categoryUser,
        salesUser,
        trader,
        procurement,
        procurementUser1,
        procurementUser2,
        operations,
        operationsUser1,
        operationsUser2,
        salesUserParent,
        salesUser1,
        salesUser2,
      ],
    },
    {
      label: 'job_MaterialReturn',
      key: materialReturn,
      permission: [
        refurbisher,
        refurbisherUser,
        recycler,
        trader,
        procurement,
        operations,
        sales,
      ],
    },
    {
      label: 'job_DestructionRequest',
      key: destructionRequest,
      permission: [admin],
    },

    {
      label: 'job_SortingJob',
      key: sorting,
      permission: [refurbisher, producer],
      hidden: loginUserDetails =>
        include([refurbisher, refurbisherUser], loginUserDetails?.roleId) &&
        !include(['job_Plastic'], loginUserDetails?.materialType),
    },
    {
      label: 'job_GrindingJob',
      key: grinding,
      permission: [refurbisher, producer],
      hidden: loginUserDetails =>
        include([refurbisher, refurbisherUser], loginUserDetails?.roleId) &&
        !include(['job_Plastic'], loginUserDetails?.materialType),
    },
    {
      label: 'job_PreCompoundingPelletizingJob',
      key: pelletizing,
      permission: [refurbisher, producer],
      hidden: loginUserDetails =>
        include([refurbisher, refurbisherUser], loginUserDetails?.roleId) &&
        !include(['job_Plastic'], loginUserDetails?.materialType),
    },
    // {
    //   label: 'job_VirginMaterialPurchase',
    //   key: virginMaterialPurchase,
    //   permission: [refurbisher, producer],
    //   hidden: loginUserDetails =>
    //     include([refurbisher, refurbisherUser], loginUserDetails?.roleId) &&
    //     !include(['job_Plastic'], loginUserDetails?.materialType),
    // },
    {
      label: 'job_CompoundingPelletizingJob',
      key: compoundingPelletizing,
      permission: [refurbisher, producer],
      hidden: loginUserDetails =>
        include([refurbisher, refurbisherUser], loginUserDetails?.roleId) &&
        !include(['job_Plastic'], loginUserDetails?.materialType),
    },
    {
      label: 'home_Refurbishment',
      key: smelting,
      permission: [
        admin,
        refurbisher,
        refurbisherUser,
        nationalGov,
        nationalGovUser,
        spcbGov,
        spcbGovUser,
        districtGov,
        districtGovUser,
        cpcbGov,
        cpcbGovUser,
        consumer,
        consumerUser,
        disposer,
        disposerUser,
        producer,
        producerUser,
        procurement,
        procurementUser1,
        procurementUser2,
        operations,
        operationsUser1,
        operationsUser2,
        salesUserParent,
        salesUser1,
        salesUser2,
      ],
      hidden: loginUserDetails =>
        include([refurbisher, refurbisherUser], loginUserDetails?.roleId) &&
        include(['job_Plastic'], loginUserDetails?.materialType),
    },
    {
      label: 'job_PostMaterialProduction',
      key: postProcessing,
      permission: [
        admin,
        refurbisher,
        procurement,
        procurementUser1,
        procurementUser2,
        operations,
        operationsUser1,
        operationsUser2,
        salesUserParent,
        salesUser1,
        salesUser2,
        producer,
      ],
      hidden: loginUserDetails =>
        include([refurbisher, refurbisherUser], loginUserDetails?.roleId) &&
        include(['job_Plastic'], loginUserDetails?.materialType),
    },
    {
      label: 'job_Shredding',
      key: shredding,
      permission: [refurbisher],
      hidden: loginUserDetails =>
        include([refurbisher, refurbisherUser], loginUserDetails?.roleId) &&
        !loginUserDetails?.doAbleJobs?.shredding,
    },
    {
      label: 'job_Hydrometallurgy',
      key: hydrometallurgy,
      permission: [refurbisher],
      hidden: loginUserDetails =>
        include([refurbisher, refurbisherUser], loginUserDetails?.roleId) &&
        !loginUserDetails?.doAbleJobs?.Hydrometallurgy,
    },
    {
      label: 'job_MaterialSalesMaterialProducer',
      key: materialSalesMaterialProducer,
      permission: [admin, refurbisher, refurbisherUser, producer, producerUser],
    },
    {
      label: 'job_MaterialSalesSupplier',
      key: materialSalesSupplier,
      permission: [
        admin,
        supplier,
        supplierUser,
        refurbisher,
        refurbisherUser,
        producer,
        producerUser,
        procurement,
        procurementUser1,
        procurementUser2,
        operations,
        operationsUser1,
        operationsUser2,
        salesUserParent,
        salesUser1,
        salesUser2,
      ],
    },
    {
      label: 'job_SupplierProduction',
      key: supplierProduction,
      permission: [
        admin,
        supplier,
        supplierUser,
        producer,
        producerUser,
        refurbisher,
        refurbisherUser,
      ],
      hidden: loginUserDetails =>
        (include([refurbisher, refurbisherUser], loginUserDetails?.roleId) &&
          !loginUserDetails?.otherDoableJobTags
            ?.map(item => item?.name)
            ?.includes('Part Production')) ||
        !isEqual(
          loginUserDetails?.materialTypes?.[0]?.materialTypeKey,
          'job_Plastic',
        ),
    },
    {
      label: 'job_Forging',
      key: forging,
      permission: [admin, supplier, supplierUser, producer, producerUser],
      hidden: loginUserDetails =>
        include(['job_Plastic'], loginUserDetails?.materialType),
    },
    {
      label: 'job_Blanking',
      key: blanking,
      permission: [supplier, supplierUser],
      hidden: loginUserDetails =>
        include(['job_Plastic'], loginUserDetails?.materialType),
    },
    {
      label: 'job_Machining',
      key: machining,
      permission: [admin, supplier, supplierUser, producer, producerUser],
      hidden: loginUserDetails =>
        include(['job_Plastic'], loginUserDetails?.materialType),
    },
    {
      label: 'job_StampingPressing',
      key: stamping,
      permission: [admin, supplier, supplierUser, producer, producerUser],
      hidden: loginUserDetails =>
        include(['job_Plastic'], loginUserDetails?.materialType),
    },
    {
      label: 'job_Assembly',
      key: assembly,
      permission: [admin, supplier, supplierUser, producer, producerUser],
      hidden: loginUserDetails =>
        include(['job_Plastic'], loginUserDetails?.materialType),
    },
    {
      label: 'job_Painting',
      key: painting,
      permission: [admin, supplier, supplierUser, producer, producerUser],
      hidden: loginUserDetails =>
        include(['job_Plastic'], loginUserDetails?.materialType),
    },
    {
      label: 'job_PartSalesPartProducer',
      key: partSalesPartProducer,
      permission: [
        admin,
        supplier,
        supplierUser,
        producer,
        producerUser,
        refurbisher,
        refurbisherUser,
      ],
      hidden: loginUserDetails =>
        include([refurbisher, refurbisherUser], loginUserDetails?.roleId) &&
        !loginUserDetails?.otherDoableJobTags
          ?.map(item => item?.name)
          ?.includes('Part Production'),
    },
    {
      label: 'job_PartSalesProducer',
      key: materialSalesProducer,
      permission: [
        admin,
        supplier,
        supplierUser,
        producer,
        producerUser,
        refurbisher,
        refurbisherUser,
      ],
      hidden: loginUserDetails =>
        include([refurbisher, refurbisherUser], loginUserDetails?.roleId) &&
        !loginUserDetails?.otherDoableJobTags
          ?.map(item => item?.name)
          ?.includes('Part Production'),
    },
    {
      label: 'job_VehicleProduction',
      key: vehicleProduction,
      permission: [admin, producer, producerUser],
    },
    {
      label: 'job_VehicleSalesDealer',
      key: vehicleSales,
      permission: [admin, producer, dealer, dealerUser],
    },
    {
      label: 'job_VehicleSalesConsumer',
      key: vehicleSalesConsumer,
      permission: [admin, dealer, dealerUser, producer, producerUser],
    },
    {
      label: 'job_Sales',
      key: sales,
      permission: [
        admin,
        // trader,
        traderUser,
        nationalGov,
        nationalGovUser,
        spcbGov,
        spcbGovUser,
        districtGov,
        districtGovUser,
        cpcbGov,
        cpcbGovUser,
        consumer,
        consumerUser,
        disposer,
        disposerUser,
        producer,
        producerUser,
      ],
    },
  ],
}

const columnKeys = {
  action: 'action',
  read: 'read',
  all: 'txt_All',
  jobId: 'job_Id',
  managementNumber: 'job_ManagementNumber',
  contractor: 'user_Contractor',
  fieldEngineer: 'job_Assignee',
  jobTitle: 'job_Title',
  createdDate: 'user_CreationDate',
  updatedDate: 'job_UpdatedDate',
  status: 'job_Status',
  activeDays: 'job_ActiveSince',
  dealer: 'user_Dealer',
  recycler: 'user_ScrappingFacility',
  refurbisher: 'user_MaterialProducer',
  materialName: 'job_MaterialName',
  trader: 'user_Seller',
  processBatchId: 'inv_ProcessBatchId',
  noOfVehicle: 'job_NoOfVehicles',
  providedBy: 'job_ProvidedBy',
  baleBatchId: 'inv_BaleBatchId',
  requestedBy: 'job_RequestedBy',
  createdBy: 'job_CreatedBy',
  moveToRecycle: 'inv_MoveToScrappingFacilityPurchased',
  recoverySource: 'job_Source',
  dealerBusinessName: 'job_DealerBusinessName',
  collectionCenterBusinessName: 'job_CollectionCenterBusinessName',
  job_NoOfELVs: 'job_NoOfELVs',
  vehicleId: 'job_VehicleId',
  scrapDispatchDate: 'job_DispatchDate',
  batchNumber: 'job_BatchNumber',
  polymerType: 'job_PolymerType',
  supplierName: 'job_SupplierName',
  invoiceNumber: 'job_InvoiceNumber',
  tradingCompanyInvoiceNumber: 'user_TradingCompanyInvoiceNumber',
  grade: 'job_Grade',
  quantity: 'job_Quantity',
  requestedDate: 'job_RequestedDate',
  shipmentDate: 'job_ShipmentDate',
  receivedDate: 'job_ReceivedDate',
  OEMName: 'inv_OEMName',
  rvsfVehicleNumber: 'job_RVSFVehicleNo',
  registrationNumber: 'job_RegistrationNumber',
  chassisNumber: 'job_ChassisNumber',
  engineNumber: 'job_EngineNumber',
  elvType: 'job_ELVType',
  rcAvailability: 'job_RCAvailability',
  source: 'job_Source',
  category: 'job_Category',
  makerName: 'user_ProducerName',
  heatNumber: 'job_HeatNumber',
  productionNumber: 'job_ProductionNumber',
  recyclerDispatchTo: 'job_RecyclerNameDispatchedTo',
  quantityKG: 'job_QuantityKG',
  sfNameRequestedBy: 'job_SFNameRequestedBy',
  inputInvoiceNumber: 'job_InputInvoiceNumber',
  outputBatchNumber: 'job_OutputBatchNumber',
  inputBatchNumber: 'job_InputBatchNumber',
  forgedBatchNumber: 'job_ForgedBatchNumber',
  blankingBatchNumber: 'job_OutputBatchNumber',
  machiningBatchNumber: 'job_MachiningBatchNumber',
  stampingBatchNumber: 'job_StampingBatchNumber',
  assemblyBatchNumber: 'job_AssemblyBatchNumber',
  paintingBatchNumber: 'job_PaintingBatchNumber',
  partNumber: 'job_PartNumber',
  partName: 'job_PartName',
  typeOfProduct: 'job_TypeOfProduct',
  totalOutputWeightNos: 'job_TotalOutputWeight',
  yield: 'job_Yield',
  dateOfForging: 'job_DateOfForging',
  dateOfBlanking: 'job_DateOfBlanking',
  dateOfMachining: 'job_DateOfMachining',
  dateOfStamping: 'job_DateOfStamping',
  dateOfAssembly: 'job_DateOfAssembly',
  dateOfPainting: 'job_DateOfPainting',
  outputPolymerType: 'job_OutputPolymerType',
  color: 'job_Color',
  recyclerName: 'user_RecyclerName',
  quantityNos: 'job_QuantityNos',
  productionId: 'job_ProductionID',
  dealerName: 'job_DealerName',
  bucketName: 'job_BucketName',
  shippedDate: 'job_ShippedDate',
  receptionDate: 'job_ReceptionDate',
  productionDate: 'job_ProductionDate',
  dateOfReceiptOfVehicle: 'job_DateOfReceiptOfVehicle',
  modelName: 'job_ModelName',
  fuelType: 'job_FuelType',
  pcrMaterialCategory: 'job_PcrMaterialCategory',
  pcrLotBatchNumber: 'job_PCRLotBatchNumber',
  pcrCountryOfOrigin: 'inv_CountryOfOrigin',
  pcrSupplierType: 'job_SupplierType',
  pcrSupplierName: 'inv_SupplierName',
  pcrCollectionDate: 'job_CollectionDate',
  pcrGrossWeightKg: 'job_GrossWeightKg',
  pcrNetWeightKg: 'job_NetWeightKg',
  pirMaterialCategory: 'job_PcrMaterialCategory',
  pirLotBatchNumber: 'job_PIRLotBatchNumber',
  pirGeneratorType: 'job_GeneratorType',
  pirGeneratorName: 'job_GeneratorName',
  pirGenerationDate: 'job_GenerationDate',
}

export const vehicleCollectionSubTypes = [elv, testVehicles, pcr, pir]

export const vehicleCollectionTabTypes = [
  recovery,
  ...vehicleCollectionSubTypes,
]

const searchByKeys = {
  jobId: 'JOB_ID',
  recoverySource: 'SOURCE',
  mstiVehicleNo: 'MSTI_VEHICLE_NUMBER',
  vehicleRegistrationNo: 'VEHICLE_REGISTRATION_NUMBER',
  makerBusinessName: 'PRODUCER_BUSINESSNAM',
  rcAvailability: 'RC_AVAILABILTY',
  chassisNumber: 'CHASSIS_NUMBER',
  engineNumber: 'ENGINE_NUMBER',
  dealerBusinessName: 'DEALER_BUSINESSNAME',
  collectionCenterBusinessName: 'COLLECTION_CENTER_BUSINESSNAME',
  bucketName: 'BUCKET_NAME',
  recyclerBusinessName: 'RECYCLER_BUSINESSNAME',
  materialProducerName: 'MATERIAL_PRODUCER_BUSINESSNAME',
  vehicleType: 'VEHICLE_WHEEL_TYPE',
  elvType: 'ELV_TYPE',
  invoiceNumber: 'INVOICE_NUMBER',
  tradingCompanyInvoiceNumber: 'TRADING_INVOICE_NO',
  materialName: 'MATERIAL_NAME',
  scrappingFacilityName: 'RECYCLER_BUSINESSNAME',
  batchNumber: 'BATCH_NUMBER',
  heatNumber: 'BATCH_NUMBER',
  supplierName: 'PART_PRODUCER_BUSINESSNAME',
  OEMName: 'OEM_NAME',
  materialGrade: 'GRADE_COMPOSITION',
  recyclerDispatchTo: 'MATERIAL_PRODUCER_BUSINESSNAME',
  quantityKG: 'QUANTITY',
  status: 'JOB_STATUS',
  sfNameRequestedBy: 'RECYCLER_BUSINESSNAME',
  inputInvoiceNumber: 'INVOICE_NUMBER',
  outputBatchNumber: 'OUTPUT_BATCH_NUMBER',
  outputPolymerType: 'POLYMER_TYPE',
  managementNumber: 'MANAGEMENT_NUMBER',
  typeOfProduct: 'TYPE_OF_PRODUCT',
  totalOutputWeightNos: 'QUANTITY',
  partNumber: 'PART_NUMBER',
  polymerType: 'POLYMER_TYPE',
  color: 'COLOR',
  recyclerName: 'RECYCLER_BUSINESSNAME',
  quantityNos: 'QUANTITY',
  productionId: 'PRODUCTION_ID',
  dealerName: 'DEALER_BUSINESSNAME',
  inputBatchNumber: 'INPUT_BATCH_NUMBER',
  forgedBatchNumber: 'OUTPUT_BATCH_NUMBER',
  blankingBatchNumber: 'OUTPUT_BATCH_NUMBER',
  machiningBatchNumber: 'OUTPUT_BATCH_NUMBER',
  stampingBatchNumber: 'OUTPUT_BATCH_NUMBER',
  assemblyBatchNumber: 'OUTPUT_BATCH_NUMBER',
  paintingBatchNumber: 'OUTPUT_BATCH_NUMBER',
  fuelType: 'FUEL_TYPE',
  supplierBusinessName: 'SUPPLIER_BUSINESSNAME',
  pcrMaterialCategory: 'PCR_MATERIAL_CATEGORY',
  pcrLotBatchNumber: 'BATCH_NUMBER',
  pcrPolymerAlloyGrade: 'POLYMER_ALLOY_GRADE',
  pcrCountryOfOrigin: 'COUNTRY_SOURCE',
  pcrMaterialForm: 'MATERIAL_FORM',
  pcrSupplierName: 'SUPPLIER_BUSINESSNAME',
  pcrNetWeightKg: 'NET_WEIGHT',
  pcrCollectionDate: 'PCR_COLLECTION_DATE',
  pcrDateOfIntakeAtFacility: 'DATE_OF_INTAKE_AT_FACILITY',
  pirMaterialCategory: 'PCR_MATERIAL_CATEGORY',
  pirLotBatchNumber: 'BATCH_NUMBER',
  pirPolymerAlloyGrade: 'POLYMER_ALLOY_GRADE',
  pirGeneratorName: 'GENERATOR_BUSINESSNAME',
  pirGenerationDate: 'GENERATION_DATE',
  pirDateOfIntakeAtFacility: 'DATE_OF_INTAKE_AT_FACILITY',
}

const {
  jobId,
  recoverySource,
  mstiVehicleNo,
  vehicleRegistrationNo,
  rcAvailability,
  chassisNumber,
  engineNumber,
  vehicleType,
  makerBusinessName,
  dealerBusinessName,
  collectionCenterBusinessName,
  bucketName,
  // materialProducerName,
  // recyclerBusinessName,
  // elvType,
  invoiceNumber,
  tradingCompanyInvoiceNumber,
  // materialName,
  // scrappingFacilityName,
  batchNumber,
  heatNumber,
  supplierName,
  OEMName,
  materialGrade,
  recyclerDispatchTo,
  quantityKG,
  polymerType,
  color,
  status,
  sfNameRequestedBy,
  inputInvoiceNumber,
  outputBatchNumber,
  outputPolymerType,
  managementNumber,
  recyclerName,
  typeOfProduct,
  totalOutputWeightNos,
  partNumber,
  quantityNos,
  productionId,
  dealerName,
  inputBatchNumber,
  forgedBatchNumber,
  // blankingBatchNumber,
  machiningBatchNumber,
  stampingBatchNumber,
  assemblyBatchNumber,
  paintingBatchNumber,
  fuelType,
  supplierBusinessName,
  pcrMaterialCategory,
  pcrLotBatchNumber,
  pcrPolymerAlloyGrade,
  pcrCountryOfOrigin,
  pcrMaterialForm,
  pcrSupplierName,
  pcrNetWeightKg,
  pcrCollectionDate,
  pcrDateOfIntakeAtFacility,
  pirMaterialCategory,
  pirLotBatchNumber,
  pirPolymerAlloyGrade,
  pirGeneratorName,
  pirGenerationDate,
  pirDateOfIntakeAtFacility,
} = searchByKeys

const pcrSelectSearchByValues = [
  pcrMaterialCategory,
  pcrPolymerAlloyGrade,
  pcrCountryOfOrigin,
  pcrMaterialForm,
]

const pcrDateSearchByValues = [pcrCollectionDate, pcrDateOfIntakeAtFacility]

const pirSelectSearchByValues = [
  pirMaterialCategory,
  pirPolymerAlloyGrade,
  pcrCountryOfOrigin,
  pcrMaterialForm,
]

const pirDateSearchByValues = [pirGenerationDate, pirDateOfIntakeAtFacility]

const searchByLabels = {
  jobId: 'job_Id',
  recoverySource: 'job_Source',
  mstiVehicleNo: 'job_RVSFVehicleNo',
  vehicleRegistrationNo: 'job_VehicleRegistrationNumber',
  rcAvailability: 'job_RCAvailability',
  chassisNumber: 'job_ChassisNumber',
  engineNumber: 'job_EngineNumber',
  makerBusinessName: 'job_MakerBusinessName',
  dealerBusinessName: 'job_DealerBusinessName',
  collectionCenterBusinessName: 'job_CollectionCenterBusinessName',
  bucketName: 'job_BucketName',
  materialProducerName: 'user_RefurbisherName',
  recyclerBusinessName: 'job_ScrappingFacilityBusinessName',
  elvType: 'job_ELVType',
  invoiceNumber: 'job_InvoiceNumber',
  tradingCompanyInvoiceNumber: 'user_TradingCompanyInvoiceNumber',
  materialName: 'job_MaterialName',
  scrappingFacilityName: 'inv_ScrappingFacilityName',
  batchNumber: 'job_BatchNumber',
  supplierName: 'inv_SupplierName',
  materialGrade: 'job_Grade',
  OEMName: 'inv_OEMName',
  heatNumber: 'job_HeatNumber',
  recyclerDispatchTo: 'job_RecyclerNameDispatchedTo',
  quantityKG: 'job_QuantityKG',
  status: 'job_Status',
  sfNameRequestedBy: 'job_SFNameRequestedBy',
  inputInvoiceNumber: 'job_InputInvoiceNumber',
  outputBatchNumber: 'job_OutputBatchNumber',
  outputPolymerType: 'job_OutputPolymerType',
  managementNumber: 'job_ManagementNumber',
  typeOfProduct: 'job_TypeOfProduct',
  totalOutputWeightNos: 'job_TotalOutputWeight',
  partNumber: 'job_PartNumber',
  polymerType: 'job_PolymerType',
  color: 'job_Color',
  recyclerName: 'user_RecyclerName',
  quantityNos: 'job_QuantityNos',
  productionId: 'job_ProductionID',
  dealerName: 'job_DealerName',
  inputBatchNumber: 'job_InputBatchNumber',
  forgedBatchNumber: 'job_ForgedBatchNumber',
  blankingBatchNumber: 'job_OutputBatchNumber',
  machiningBatchNumber: 'job_MachiningBatchNumber',
  stampingBatchNumber: 'job_StampingBatchNumber',
  assemblyBatchNumber: 'job_AssemblyBatchNumber',
  paintingBatchNumber: 'job_PaintingBatchNumber',
  vehicleType: 'job_VehicleType',
  fuelType: 'job_FuelType',
  supplierBusinessName: 'inv_SupplierName',
  pcrMaterialCategory: 'job_PcrMaterialCategory',
  pcrLotBatchNumber: 'job_PCRLotBatchNumber',
  pcrPolymerAlloyGrade: 'job_PolymerAlloyGrade',
  pcrCountryOfOrigin: 'inv_CountryOfOrigin',
  pcrMaterialForm: 'job_MaterialForm',
  pcrSupplierName: 'inv_SupplierName',
  pcrNetWeightKg: 'job_NetWeightKg',
  pcrCollectionDate: 'job_CollectionDate',
  pcrDateOfIntakeAtFacility: 'job_DateOfIntakeAtFacility',
  pirMaterialCategory: 'job_PirMaterialCategory',
  pirLotBatchNumber: 'job_PIRLotBatchNumber',
  pirPolymerAlloyGrade: 'job_PolymerAlloyGrade',
  pirGeneratorName: 'job_GeneratorName',
  pirGenerationDate: 'job_GenerationDate',
  pirDateOfIntakeAtFacility: 'job_DateOfIntakeAtFacility',
}

const payloadType = {
  [recovery]: 'RECOVERY',
  [elv]: 'RECOVERY',
  [testVehicles]: 'RECOVERY',
  [pcr]: 'RECOVERY',
  [pir]: 'RECOVERY',
  [recycleRequest]: 'RECYCLE_REQUEST',
  [process]: 'PROCESS',
  [bucketCreation]: 'BUCKET_CREATION',
  [recycle]: 'RECYCLE',
  [smeltingRequest]: 'RECYCLE',
  [sorting]: 'SORTING',
  [grinding]: 'GRINDING',
  [pelletizing]: 'PRE_COMPOUNDING_PELLETIZING',
  [materialSalesMaterialProducer]: 'MATERIAL_SALES_MATERIAL_PRODUCER',
  [compoundingPelletizing]: 'COMPOUNDING_PELLETIZING',
  [materialSalesSupplier]: 'MATERIAL_SALES_PART_PRODUCER',
  [smelting]: 'MATERIAL_PRODUCTION',
  [supplierProduction]: 'PART_PRODUCTION',
  [forging]: 'FORGING',
  [blanking]: 'BLANKING',
  [machining]: 'MACHINING',
  [stamping]: 'STAMPING',
  [assembly]: 'ASSEMBLY',
  [painting]: 'PAINTING',
  [partSalesPartProducer]: 'PART_SALES_PART_PRODUCER',
  [materialSalesProducer]: 'PART_SALES_PRODUCER',
  [virginMaterialPurchase]: 'VIRGIN_PRODUCTION',
  [vehicleProduction]: 'VEHICLE_PRODUCTION',
  [postProcessing]: 'POST_PROCESSING',
  [materialReturn]: 'MATERIAL_RETURN',
}

const scrapTypePayload = userMaterialType => ({
  [materialSalesSupplier]: {
    job_Plastic: 'POST_COMPOUNDED_PELLETS',
    inv_CastIron: 'HEAT',
    job_Steel: 'HEAT',
    job_Aluminium: 'HEAT',
    job_Zinc: 'HEAT',
    job_Copper: 'HEAT',
    job_Rubber: 'HEAT',
    inv_PlatinumAndPalladium: 'HEAT',
    job_Battery: 'HEAT',
    job_UsedOil: 'HEAT',
  }[userMaterialType],
  [smelting]: {
    job_Plastic: 'BUCKET',
    inv_CastIron: 'HEAT_BILLETS',
    job_Steel: 'HEAT_BILLETS',
    job_Aluminium: 'HEAT_BILLETS',
    job_Zinc: 'HEAT_BILLETS',
    job_Copper: 'HEAT_BILLETS',
    job_Rubber: 'HEAT_BILLETS',
    inv_PlatinumAndPalladium: 'HEAT_BILLETS',
    job_Battery: 'HEAT_BILLETS',
    job_UsedOil: 'HEAT_BILLETS',
  }[userMaterialType],
  [postProcessing]: {
    job_Steel: 'HEAT',
    inv_CastIron: 'HEAT',
    job_Aluminium: 'HEAT',
    job_Zinc: 'HEAT',
    job_Copper: 'HEAT',
    job_Rubber: 'HEAT',
    inv_PlatinumAndPalladium: 'HEAT',
    job_Battery: 'HEAT',
    job_UsedOil: 'HEAT',
  }[userMaterialType],
})

const recoverySteps = [
  'job_Date',
  'job_ScrapType',
  'job_CollectionData',
  'job_Remarks',
  'job_Confirm',
  'job_Complete',
]

const sortingJobSteps = [
  'job_Date',
  'job_JobDetails',
  'job_Remarks',
  'job_Confirm',
  'job_Complete',
]
const virginMaterialPurchaseSteps = [
  'job_Date',
  'job_JobDetails',
  'job_Remarks',
  'job_Confirm',
  'job_Complete',
]

const pelletizingJobSteps = [
  'job_Date',
  'job_JobDetails',
  'job_Remarks',
  'job_Confirm',
  'job_Complete',
]

const hydrometallurgyProcessSteps = {
  process: [
    'job_Date',
    'job_JobDetails',
    'job_Remarks',
    'job_Confirm',
    'job_Complete',
  ],
}

const salesSteps = [
  'job_Date',
  'job_BuyerAndLocation',
  'job_SalesList',
  'job_Remarks',
  'job_Confirm',
  'job_Complete',
]

const smelterFormSteps = {
  request: [
    'user_MaterialProducer',
    'inv_Bucket',
    'job_Transport',
    'job_Remarks',
    'job_Confirm',
    'job_Complete',
  ],
  accumulation: ['job_RequestedDetails', 'job_Transport', 'job_Complete'],
  reception: ['job_RequestedDetails', 'job_ReceiveBuckets', 'job_Complete'],
  process: [
    'job_Date',
    'job_JobDetails',
    'job_Remarks',
    'job_Confirm',
    'job_Complete',
  ],
}

const recycleFormSteps = {
  request: [
    'user_ScrappingFacility',
    'job_Scrap',
    'job_Transport',
    'job_Remarks',
    'job_Confirm',
    'job_Complete',
  ],
  accumulation: ['job_RequestedDetails', 'job_Transport', 'job_Complete'],
  reception: ['job_RequestedDetails', 'job_ReceiveScraps', 'job_Complete'],
  process: [
    'job_Date',
    'job_ScrapELVDetails',
    // 'job_JobDetails',
    'job_Remarks',
    'job_Confirm',
    'job_Complete',
  ],
  recycleLoginStep: [
    'job_Date',
    'job_JobDetails',
    'job_Remarks',
    'job_Confirm',
    'job_Complete',
  ],
}

const processFormSteps = {
  process: [
    'job_Date',
    'job_Vehicle',
    'job_Remarks',
    'job_Confirm',
    'job_Complete',
  ],
}
const bucketCreationFormSteps = {
  creation: [
    'job_Date',
    'job_ProcessJob',
    'job_BucketDetails',
    'job_Remarks',
    'job_Confirm',
    'job_Complete',
  ],
}

const supplierProductionSteps = [
  'job_Date',
  'job_JobDetails',
  'job_Remarks',
  'job_Confirm',
  'job_Complete',
]

const forgingSteps = [
  'job_Date',
  'job_ForgingInputDetails',
  'job_Remarks',
  'job_Confirm',
  'job_Complete',
]

const blankingSteps = [
  'job_Date',
  'job_BlankingInputDetails',
  'job_Remarks',
  'job_Confirm',
  'job_Complete',
]

const machiningSteps = [
  'job_Date',
  'job_MachiningInputDetails',
  'job_Remarks',
  'job_Confirm',
  'job_Complete',
]

const stampingSteps = [
  'job_Date',
  'job_StampingInputDetails',
  'job_Remarks',
  'job_Confirm',
  'job_Complete',
]

const assemblySteps = [
  'job_Date',
  'job_AssemblyInputDetails',
  'job_Remarks',
  'job_Confirm',
  'job_Complete',
]

const paintingSteps = [
  'job_Date',
  'job_PaintingInputDetails',
  'job_Remarks',
  'job_Confirm',
  'job_Complete',
]

const destructionRequestSteps = [
  'user_Disposer',
  'inv_Bucket',
  'job_Transport',
  'job_Remarks',
  'job_Confirm',
  'job_Complete',
]
const thirdPartyRecycleSteps = [
  'user_MaterialProducer',
  'inv_Bucket',
  'job_Transport',
  'job_Remarks',
  'job_Confirm',
  'job_Complete',
]
const reuseRequestSteps = [
  'user_SecondHandBuyer',
  'inv_Bucket',
  'job_Transport',
  'job_Remarks',
  'job_Confirm',
  'job_Complete',
]

const materialSalesSupplierFormSteps = {
  request: [
    'home_Refurbishment',
    'job_JobDetails',
    'job_Remarks',
    'job_Confirm',
    'job_Complete',
  ],
  accumulation: ['job_RequestedDetails', 'tag_FinalProduct', 'job_Complete'],
}
const vehicleProductionSteps = [
  'job_Date',
  'job_JobDetails',
  'job_Remarks',
  'job_Confirm',
  'job_Complete',
]
const materialSalesProducerFormSteps = {
  request: [
    'user_Supplier',
    'job_JobDetails',
    'job_Remarks',
    'job_Confirm',
    'job_Complete',
  ],
  accumulation: ['job_RequestedDetails', 'tag_FinalProduct', 'job_Complete'],
}

const vehicleSalesSteps = [
  'job_Date',
  'job_BuyerAndLocation',
  'job_VehicleSold',
  'job_Remarks',
  'job_Confirm',
  'job_Complete',
]

const materialSalesMaterialProducerSteps = {
  request: [
    'job_Date',
    'job_Product',
    'job_Remarks',
    'job_Confirm',
    'job_Complete',
  ],
  accumulation: ['job_RequestedDetails', 'job_Product', 'job_Complete'],
}

const partSalesPartProducerSteps = {
  request: [
    'job_Date',
    'job_Product',
    'job_Remarks',
    'job_Confirm',
    'job_Complete',
  ],
  accumulation: ['job_RequestedDetails', 'job_Product', 'job_Complete'],
}

const recycleListAttr = {
  tyerCNGData: {
    title: 'job_RegisterTyreCNGGasData',
    fieldAttr: {
      tyre: {
        label: 'job_Tyre',
        inputType: 'input',
        className: 'w-100',
        md: 12,
        sm: 24,
      },
      cng: {
        label: 'job_CNGGas',
        inputType: 'inputNumber',
        className: 'w-100',
        addonAfter: 'Kg',
        md: 12,
        sm: 24,
      },
    },
  },
  batteryFreonGas: {
    title: 'job_RegisterBatteryFreonGasSpareTypeData',
    fieldAttr: {
      battery: {
        label: 'job_Battery',
        inputType: 'input',
        className: 'w-100',
        md: 12,
        sm: 24,
      },
      freonGas: {
        label: 'job_FreonGas',
        inputType: 'inputNumber',
        className: 'w-100',
        addonAfter: 'Kgs',
        md: 12,
        sm: 24,
      },
      spareTyre: {
        label: 'job_SpareTyre',
        inputType: 'input',
        className: 'w-100',
        md: 8,
        sm: 24,
      },
      kit: {
        label: 'job_Kit',
        inputType: 'input',
        className: 'w-100',
        md: 8,
        sm: 24,
      },
      others: {
        label: 'dash_Others',
        inputType: 'input',
        className: 'w-100',
        md: 8,
        sm: 24,
      },
    },
  },
  depollution: {
    title: 'job_RegisterDepollutionData',
    fieldAttr: {
      muffler: {
        label: 'job_Muffler',
        inputType: 'input',
        className: 'w-100',
        md: 12,
        sm: 24,
      },
      fuelTankFuel: {
        label: 'job_FuelTankAndFuel',
        inputType: 'input',
        className: 'w-100',
        md: 12,
        sm: 24,
      },
      engineOil: {
        label: 'job_EngineOil',
        inputType: 'inputNumber',
        className: 'w-100',
        addonAfter: 'ml',
        md: 8,
        sm: 24,
      },
      transmissionOil: {
        label: 'job_TransmissionOil',
        inputType: 'inputNumber',
        className: 'w-100',
        addonAfter: 'ml',
        md: 8,
        sm: 24,
      },
      coolant: {
        label: 'job_Coolant',
        inputType: 'inputNumber',
        className: 'w-100',
        addonAfter: 'ml',
        md: 8,
        sm: 24,
      },
      brakeOil: {
        label: 'job_BrakeOil',
        inputType: 'inputNumber',
        className: 'w-100',
        addonAfter: 'ml',
        md: 8,
        sm: 24,
      },
      steeringOil: {
        label: 'job_SteeringOil',
        inputType: 'inputNumber',
        className: 'w-100',
        addonAfter: 'ml',
        md: 8,
        sm: 24,
      },
      windshieldLiquid: {
        label: 'job_WindshieldLiquid',
        inputType: 'inputNumber',
        className: 'w-100',
        addonAfter: 'ml',
        md: 8,
        sm: 24,
      },
    },
  },
  bodyPanel: {
    title: 'job_RegisterBodyPanel',
    fieldAttr: {
      doors: {
        label: 'job_Doors',
        inputType: 'input',
        className: 'w-100',
        md: 8,
        sm: 24,
      },
      bonnet: {
        label: 'job_Bonnet',
        inputType: 'input',
        className: 'w-100',
        md: 8,
        sm: 24,
      },
      fenders: {
        label: 'job_Fenders',
        inputType: 'input',
        className: 'w-100',
        md: 8,
        sm: 24,
      },
      bumpers: {
        label: 'job_Bumpers',
        inputType: 'input',
        className: 'w-100',
        md: 8,
        sm: 24,
      },
      headLights: {
        label: 'job_HeadLights',
        inputType: 'input',
        className: 'w-100',
        md: 8,
        sm: 24,
      },
      tailLights: {
        label: 'job_TailLights',
        inputType: 'input',
        className: 'w-100',
        md: 8,
        sm: 24,
      },
    },
  },
  interiorParts: {
    title: 'job_RegisterInteriorParts',
    fieldAttr: {
      seats: {
        label: 'job_Seats',
        inputType: 'input',
        className: 'w-100',
        md: 8,
        sm: 24,
      },
      steering: {
        label: 'job_Steering',
        inputType: 'input',
        className: 'w-100',
        md: 8,
        sm: 24,
      },
      dashboard: {
        label: 'job_Dashboard',
        inputType: 'input',
        className: 'w-100',
        md: 8,
        sm: 24,
      },
      floorMat: {
        label: 'job_FloorMat',
        inputType: 'input',
        className: 'w-100',
        md: 8,
        sm: 24,
      },
      rooflining: {
        label: 'job_Rooflining',
        inputType: 'input',
        className: 'w-100',
        md: 8,
        sm: 24,
      },
      interiorParts: {
        label: 'job_InteriorParts',
        inputType: 'input',
        className: 'w-100',
        md: 8,
        sm: 24,
      },
    },
  },
  wireHarness: {
    title: 'job_RegisterWireHarnessData',
    fieldAttr: {
      wiring: {
        label: 'job_WiringHarness',
        inputType: 'input',
        className: 'w-100',
        md: 12,
        sm: 24,
      },
      smallInteriorParts: {
        label: 'job_SmallInteriorParts',
        inputType: 'input',
        className: 'w-100',
        md: 12,
        sm: 24,
      },
    },
  },
  engineSuspension: {
    title: 'job_EngineSuspensionRadiatorData',
    fieldAttr: {
      engine: {
        label: 'job_Engine',
        inputType: 'input',
        className: 'w-100',
        md: 12,
        sm: 24,
      },
      frontRearSuspension: {
        label: 'job_FrontRearSuspension',
        inputType: 'input',
        className: 'w-100',
        md: 12,
        sm: 24,
      },
      radiatorAssembly: {
        label: 'job_RadiatorAssembly',
        inputType: 'input',
        className: 'w-100',
        md: 8,
        sm: 24,
      },
      brakeLining: {
        label: 'job_BrakeLining',
        inputType: 'input',
        className: 'w-100',
        md: 8,
        sm: 24,
      },
      engineRoomWiring: {
        label: 'job_EngineRoomWiringHarness',
        inputType: 'input',
        className: 'w-100',
        md: 8,
        sm: 24,
      },
    },
  },
  miscellaneousParts: {
    title: 'job_MiscellaneousParts',
    fieldAttr: {
      engineRoom: {
        label: 'job_EngineRoomMiscellaneousItems',
        inputType: 'input',
        className: 'w-100',
        md: 12,
        sm: 24,
      },
      glasses: {
        label: 'job_Glasses',
        inputType: 'input',
        className: 'w-100',
        md: 12,
        sm: 24,
      },
      trims: {
        label: 'job_Trims',
        inputType: 'input',
        className: 'w-100',
        md: 12,
        sm: 24,
      },
      plasticFastners: {
        label: 'job_PlasticFastners',
        inputType: 'input',
        className: 'w-100',
        md: 12,
        sm: 24,
      },
      VINNumber: {
        label: 'job_VINNumber',
        inputType: 'input',
        className: 'w-100',
        md: 12,
        sm: 24,
      },
      chassisNumber: {
        label: 'job_ChassisNumberCutOut',
        inputType: 'input',
        className: 'w-100',
        md: 12,
        sm: 24,
      },
    },
  },
  steelData: {
    title: 'job_SteelDataBaleShredded',
    fieldAttr: {
      materialType: {
        label: 'job_MaterialType',
        inputType: 'input',
        // options: optionFilter(materialTypeOptions),
        required: true,
        md: 24,
        sm: 24,
        disabled: true,
      },
      grade: {
        label: 'job_MaterialCompositionGrade',
        inputType: 'input',
        required: true,
        className: 'w-100',
        md: 12,
        sm: 24,
      },
      weight: {
        label: 'job_Weight',
        inputType: 'input',
        required: true,
        className: 'w-100',
        md: 12,
        sm: 24,
      },
      dimension: {
        title: 'job_Dimension',
        hidden: true,
      },
      dLength: {
        label: 'job_Length',
        inputType: 'inputNumber',
        required: true,
        className: 'w-100',
        md: 8,
        sm: 24,
        addonAfter: 'feet',
      },
      dWidth: {
        label: 'job_Width',
        inputType: 'inputNumber',
        required: true,
        className: 'w-100',
        md: 8,
        sm: 24,
        addonAfter: 'feet',
      },
      dHeight: {
        label: 'job_Height',
        inputType: 'inputNumber',
        required: true,
        className: 'w-100',
        md: 8,
        sm: 24,
        addonAfter: 'feet',
      },
    },
  },
}

const categoryELVOptions = [
  {
    label: 'job_CategoryELV1',
    value: 'Category I',
  },
  {
    label: 'job_CategoryELV2',
    value: 'Category II',
  },
  {
    label: 'job_CategoryELV3',
    value: 'Category III',
  },
  {
    label: 'job_CategoryELV4',
    value: 'Category IV',
  },
  {
    label: 'job_CategoryELV5',
    value: 'Category V',
  },
  {
    label: 'job_CategoryELV6',
    value: 'Category VI',
  },
  {
    label: 'job_CategoryELV7',
    value: 'Category VII',
  },
]

const manualBaleInputFields = {
  totalWeight: {
    label: 'job_TotalWeightKgs',
    inputType: 'inputNumber',
    required: true,
    className: 'w-100',
    md: 12,
    sm: 24,
  },
  baleCount: {
    label: 'job_BaleCount',
    inputType: 'inputNumber',
    required: true,
    className: 'w-100',
    md: 12,
    sm: 24,
  },
}

const jobWiseReport = {
  REPAIR: [
    {
      title: 'job_RepairCertificate',
      subTitle: '',
      type: 'REPAIR_JOB_CERTIFICATE',
    },
  ],
  RECOVERY: [
    {
      title: 'job_ELVSummaryReport',
      subTitle: '',
      type: 'REPAIR_JOB_CERTIFICATE',
    },
  ],
  DOWNLOAD_PAYMENT: [
    {
      title: 'job_DownloadPaymentForm',
      subTitle: '',
      type: 'REPAIR_JOB_CERTIFICATE',
      icon: 'excel',
      downloadOnly: true,
    },
  ],
  RECYCLE: [
    {
      title: 'job_RecycleCertificate',
      subTitle: '',
      type: 'REPAIR_JOB_CERTIFICATE',
    },
  ],
  RECYCLE_REQUEST: [
    {
      title: 'job_RecycleRequestCertificate',
      subTitle: '',
      type: 'REPAIR_JOB_CERTIFICATE',
    },
  ],
  DIRECT_RECOVERY: [
    {
      title: 'job_RecoveryCertificate',
      subTitle: '',
      type: 'REPAIR_JOB_CERTIFICATE',
    },
    {
      title: 'job_RecycleCertificate',
      subTitle: '',
      type: 'REPAIR_JOB_CERTIFICATE',
      hidden: [recycler, dataEntry, superUser, finance, accounts],
    },
  ],
  RECYCLE_REQUESTED: [
    {
      title: 'job_RecycleRequestCertificate',
      subTitle: '',
      type: 'REPAIR_JOB_CERTIFICATE',
    },
  ],
  OUTPUT_CERTIFICATE: [
    {
      title: 'job_OutPutCertificate',
      subTitle: '',
      type: 'REPAIR_JOB_CERTIFICATE',
    },
  ],
  EVIDENCE_CERTIFICATE: [
    {
      title: 'job_PDFEvidence',
      subTitle: '',
      type: 'REPAIR_JOB_CERTIFICATE',
    },
  ],
  GREEN_CERTIFICATE: [
    {
      title: 'job_GreenCertificate',
      subTitle: '',
      type: 'REPAIR_JOB_CERTIFICATE',
    },
  ],
  REFURBISHMENT: [
    {
      title: 'job_MaterialProductionCertificate',
      subTitle: '',
      type: 'REPAIR_JOB_CERTIFICATE',
    },
  ],
  SALES: [
    {
      title: 'job_SalesCertificate',
      subTitle: '',
      type: 'REPAIR_JOB_CERTIFICATE',
    },
  ],
  MATERIAL_SALES_SUPPLIER: [
    {
      title: 'job_MaterialSalesSupplierCertificate',
      subTitle: '',
      type: 'REPAIR_JOB_CERTIFICATE',
    },
  ],
  SUPPLIER_PRODUCTION: [],
  MATERIAL_SALES_PRODUCER: [],
  VEHICLE_PRODUCTION: [],
  VEHICLE_SALES: [],
  PRE_COMPOUNDING_PELLETIZING_COMPLETED: [
    {
      title: 'job_PreCompoundPelletizingCertificate',
      subTitle: '',
      // type: 'REPAIR_JOB_CERTIFICATE',
    },
  ],
  COMPOUNDING_PELLETIZING_COMPLETED: [
    {
      title: 'job_CompoundPelletizingCertificate',
      subTitle: '',
      // type: 'REPAIR_JOB_CERTIFICATE',
    },
  ],
  LABEL_CERT: [
    {
      title: 'job_Label',
      subTitle: '',
      type: 'REPAIR_JOB_CERTIFICATE',
    },
  ],
}

const certTagProp = {
  output: {
    color: '#6badb6',
    text: 'tag_Output',
  },
  recycle: {
    color: '#90d050',
    text: 'tag_Recycle',
  },
  green: {
    color: '#52b052',
    text: 'tag_Green',
  },
}

const shareCertificateFields = t => [
  {
    name: 'phoneNumber',
    label: 'job_SendSMS',
    validation: {
      rules: [
        {
          required: false,
          max: 12,
          pattern: new RegExp(/^[0-9-]{12,12}$/),
          message: t('error_LengthValidation'),
        },
      ],
    },
  },
  {
    name: 'emailId',
    label: 'job_SendEmail',
    validation: {
      rules: [
        {
          required: false,
          type: 'email',
          pattern: new RegExp(/[a-z0-9]+@[a-z-0-9-]+\.[a-z-0-9-]{2,3}/),
          message: t('error_InvalidEmail'),
        },
      ],
    },
  },
]

const partName = [
  { label: 'Body', value: 'Body' },
  { label: 'Bumper', value: 'Bumper' },
  { label: 'Chassis', value: 'Chassis' },
  { label: 'Engine', value: 'Engine' },
  { label: 'Transmission', value: 'Transmission' },
]

const materialOptions = [
  { label: 'job_Aluminium', value: 'Aluminium' },
  { label: 'job_Copper', value: 'Copper' },
  { label: 'job_Fe', value: 'Fe' },
  { label: 'job_Plastic', value: 'Plastic' },
  { label: 'job_BlackMass', value: 'Black Mass' },
]

const dummyRecoveryVardhman = {}
const dummyRecoveryPeeco = {}

const dummyJobList = ({ jobType, status }) => {
  return { list: [] }
}

const getDummyJob = ({ jobType, jobId, status }) => {
  const jobList = dummyJobList({ jobType, status })?.list
  return jobList?.find(job => isEqual(job?.jobId, +jobId)) || {}
}

export const MATERIAL_TYPE_ENUM = {
  job_Steel: 'STEEL',
  inv_CastIron: 'CAST_IRON',
  job_Aluminium: 'ALUMINIUM',
  job_Zinc: 'ZINC',
  job_Copper: 'COPPER',
  job_Rubber: 'RUBBER',
  inv_PlatinumAndPalladium: 'PLATINUM',
  job_Battery: 'BATTERY',
}

//after material production
export const MATERIAL_PRODUCT_TYPE = {
  job_Steel: [
    {
      id: 'STEEL_BILLET',
      name: 'Steel Billets',
      key: 'job_SteelBillets',
    },
    {
      id: 'TMT_BILLET',
      name: 'TMT Billets',
      key: 'job_TMTBillets',
    },
    {
      id: 'MILD_STEEL_BILLET',
      name: 'Mild Steel Billets',
      key: 'job_MildSteelBillets',
    },
  ],
  inv_CastIron: [
    {
      id: 'CAST_IRON_INGOTS',
      name: 'Cast Iron Ingots',
      key: 'job_CastIronIngots',
    },
    {
      id: 'CAST_IRON_BLOCKS',
      name: 'Cast Iron Blocks',
      key: 'job_CastIronBlocks',
    },
    {
      id: 'CAST_IRON_PIPES',
      name: 'Cast Iron Pipes',
      key: 'job_CastIronPipes',
    },
  ],
  job_Aluminium: [
    {
      id: 'ALUMINIUM_INGOTS',
      name: 'Aluminium Ingots',
      key: 'job_AluminiumIngots',
    },
    {
      id: 'ALUMINIUM_SHEETS',
      name: 'Aluminium Sheets',
      key: 'job_AluminiumSheets',
    },
    {
      id: 'ALUMINIUM_EXTRUSIONS',
      name: 'Aluminium Extrusions',
      key: 'job_AluminiumExtrusions',
    },
  ],
  job_Zinc: [
    {
      id: 'ZINC_INGOTS',
      name: 'Zinc Ingots',
      key: 'job_ZincIngots',
    },
    {
      id: 'ZINC_SHEETS',
      name: 'Zinc Sheets',
      key: 'job_ZincSheets',
    },
    {
      id: 'ZINC_EXTRUSIONS',
      name: 'Zinc Extrusions',
      key: 'job_ZincExtrusions',
    },
  ],
  job_Copper: [
    {
      id: 'COPPER_CATHODES',
      name: 'Copper Cathodes',
      key: 'job_CopperCathodes',
    },
    {
      id: 'COPPER_RODS',
      name: 'Copper Rods',
      key: 'job_CopperRods',
    },
    {
      id: 'COPPER_SHEETS',
      name: 'Copper Sheets',
      key: 'job_CopperSheets',
    },
  ],
  job_Rubber: [
    {
      id: 'RUBBER_SHEETS',
      name: 'Rubber Sheets',
      key: 'job_RubberSheets',
    },
    {
      id: 'RUBBER_PELLETS',
      name: 'Rubber Pellets',
      key: 'job_RubberPellets',
    },
    {
      id: 'VULCANIZED_RUBBER_BLOCKS',
      name: 'Vulcanized Rubber Blocks',
      key: 'job_VulcanizedRubberBlocks',
    },
  ],
  inv_PlatinumAndPalladium: [
    {
      id: 'PLATINUM_INGOTS',
      name: 'Platinum Ingots',
      key: 'job_PlatinumIngots',
    },
    {
      id: 'PALLADIUM_INGOTS',
      name: 'Palladium Ingots',
      key: 'job_PalladiumIngots',
    },
    {
      id: 'PLATINUM_PALLADIUM_ALLOY_PELLETS',
      name: 'Platinum/Palladium Alloy Pellets',
      key: 'job_PlatinumPalladiumAlloyPellets',
    },
  ],
  job_Battery: [
    {
      id: 'REFINED_BATTERY_MATERIALS',
      name: 'Refined Battery Materials',
      key: 'job_RefinedBatteryMaterials',
    },
    {
      id: 'GRAPHITE_POWDER',
      name: 'Graphite Powder',
      key: 'job_GraphitePowder',
    },
    {
      id: 'CATHODE_ANODE_MATERIALS',
      name: 'Cathode/Anode Materials',
      key: 'job_CathodeAnodeMaterials',
    },
  ],
}

//after post processing
export const PROCESS_PRODUCT_TYPE = {
  job_Steel: [
    {
      id: 'DIA_ROLLED_STEEL_BAR',
      name: 'Dia Rolled Steel Bars',
      key: 'job_DiaRolledSteelBars',
    },
    {
      id: 'TMT_STEEL_BAR',
      name: 'TMT Bars',
      key: 'inv_TMTBars',
    },
    {
      id: 'MILD_STEEL_BAR',
      name: 'Mild Steel Bars',
      key: 'job_MildSteelBars',
    },
    {
      id: 'SCM_440_HOT_ROLLED_ALLOY_STEEL_BAR_DIA_20MM',
      name: 'SCM 440 HOT ROLLED ALLOY STEEL BAR DIA 20MM',
      key: 'job_SCM_HOT_ROLLED_ALLOY_STEEL_BAR_DIA',
    },
  ],
  inv_CastIron: [
    {
      id: 'CAST_IRON_DRUMS',
      name: 'Cast Iron Drums',
      key: 'job_CastIronDrums',
    },
    {
      id: 'CAST_IRON_DISCS',
      name: 'Cast Iron Discs',
      key: 'job_CastIronDiscs',
    },
    {
      id: 'CAST_IRON_BLOCKS',
      name: 'Cast Iron Blocks',
      key: 'job_CastIronBlocks',
    },
  ],
  job_Aluminium: [
    {
      id: 'ALUMINIUM_WIRES',
      name: 'Aluminium Wires',
      key: 'job_AluminiumWires',
    },
    {
      id: 'ALUMINIUM_SHEETS',
      name: 'Aluminium Sheets',
      key: 'job_AluminiumSheets',
    },
    {
      id: 'ALUMINIUM_BARS',
      name: 'Aluminium Bars',
      key: 'job_AluminiumBars',
    },
  ],
  job_Zinc: [
    {
      id: 'ZINC_INGOTS',
      name: 'Zinc Ingots',
      key: 'job_ZincIngots',
    },
    {
      id: 'ZINC_SHEETS',
      name: 'Zinc Sheets',
      key: 'job_ZincSheets',
    },
    {
      id: 'ZINC_WIRES',
      name: 'Zinc Wires',
      key: 'job_ZincWires',
    },
  ],
  job_Copper: [
    {
      id: 'COPPER_WIRES',
      name: 'Copper Wires',
      key: 'job_CopperWires',
    },
    {
      id: 'COPPER_RODS',
      name: 'Copper Rods',
      key: 'job_CopperRods',
    },
    {
      id: 'COPPER_STRIPS',
      name: 'Copper Strips',
      key: 'job_CopperStrips',
    },
  ],
  job_Rubber: [
    {
      id: 'RUBBER_COMPOUND_PELLETS',
      name: 'Rubber Compound Pellets',
      key: 'job_RubberCompoundPellets',
    },
    {
      id: 'RUBBER_SHEETS',
      name: 'Rubber Sheets',
      key: 'job_RubberSheets',
    },
    {
      id: 'RUBBER_CRUMBS',
      name: 'Rubber Crumbs',
      key: 'job_RubberCrumbs',
    },
  ],
  inv_PlatinumAndPalladium: [
    {
      id: 'PLATINUM_SPONGE',
      name: 'Platinum Sponge',
      key: 'job_PlatinumSponge',
    },
    {
      id: 'PALLADIUM_SPONGE',
      name: 'Palladium Sponge',
      key: 'job_PalladiumSponge',
    },
  ],
  job_Battery: [
    {
      id: 'BATTERY_GRADE_LITHIUM_CARBONATE',
      name: 'Battery Grade Lithium Carbonate',
      key: 'job_BatteryGradeLithiumCarbonate',
    },
    {
      id: 'BATTERY_GRADE_NICKEL_SULFATE',
      name: 'Battery Grade Nickel Sulfate',
      key: 'job_BatteryGradeNickelSulfate',
    },
    {
      id: 'GRAPHITE_ANODE_POWDER',
      name: 'Graphite Anode Powder',
      key: 'job_GraphiteAnodePowder',
    },
  ],
}

export const elvPickedByOptions = [
  { label: 'TLKI-1 : 6153', value: 'TLKI1_6153' },
  { label: 'TLKI-2 : 8710', value: 'TLKI2_8710' },
  { label: 'TLKI-3 : 0047', value: 'TLKI3_0047' },
  { label: 'TLKI-4 : 8609', value: 'TLKI4_8609' },
  { label: 'TLKI-5 : 0242', value: 'TLKI5_0242' },
  { label: 'Self Drop', value: 'SELF_DROP' },
  { label: 'RSA Towing', value: 'RSA_TOWING' },
  { label: 'Car Carrier', value: 'CAR_CARRIER' },
  { label: 'Others', value: 'OTHERS' },
]
export const otherPickedByOptions = [
  { label: 'Car Carrier', value: 'CAR_CARRIER' },
  { label: 'Flatbed', value: 'FLAT_BED' },
  { label: 'Modified Car Carrier', value: 'MODIFIED_CAR_CARRIER' },
  { label: 'Others', value: 'OTHERS' },
]

export const TEST_VEHICLE_UNREGISTERED = 'job_TestVehicleUnregistered'
export const TEST_VEHICLE_REGISTERED = 'job_TestVehicleRegistered'
export const ELV = 'job_ELV'
export const OEM = 'job_OEMTestVehicle'
export const DIRECT_DEALER = 'job_DirectDealer'
export const DIRECT_INDIVIDUAL = 'job_DirectIndividual'
export const COLLECTION_CENTER = 'job_CollectionCenter'
export const YES = 'YES'
export const NO = 'NO'
export const ALONG_WITH_VEHICLE = 'ALONG_WITH_VEHICLE'
export const COMMISSION = 'COMMISSION'

export const APPROVED = 'APPROVED'
export const REJECTED = 'REJECTED'
export const PENDING = 'PENDING'
export const OTHERS = 'OTHERS'
export const Accepted = 'Accepted'

export const DEALER_COMMISSION = 4000

// Destructure column keys for easier usage
const {
  jobId: jobIdKey,
  invoiceNumber: invoiceNumberKey,
  tradingCompanyInvoiceNumber: traderInvoiceNumberKey,
  // refurbisher: materialProducerKey,
  // recycler: scrappingFacilityKey,
  // materialName: materialNameKey,
  grade: materialGradeKey,
  // quantity: quantityKey,
  scrapDispatchDate: dispatchDateKey,
  // receivedDate: receivedDateKey,
  status: statusKey,
  batchNumber: batchNumberKey,
  supplierName: supplierNameKey,
  OEMName: OEMNameKey,
  rvsfVehicleNumber: RVSFVehicleNumberKey,
  registrationNumber: RegistrationNumberKey,
  chassisNumber: ChassisNumberKey,
  engineNumber: EngineNumberKey,
  elvType: ELVTypeKey,
  rcAvailability: RCAvailabilityKey,
  source: SourceKey,
  category: CategoryKey,
  makerName: MakerNameKey,
  dealerBusinessName: DealerBusinessNameKey,
  collectionCenterBusinessName: CollectionCenterBusinessNameKey,
  createdDate: CreatedDateKey,
  activeDays: ActiveDaysKey,
  heatNumber: heatNumberKey,
  recyclerDispatchTo: recyclerDispatchToKey,
  quantityKG: quantityKGKey,
  sfNameRequestedBy: sfNameRequestedByKey,
  inputInvoiceNumber: inputInvoiceNumberKey,
  outputBatchNumber: outputBatchNumberKey,
  outputPolymerType: outputPolymerTypeKey,
  color: colorKey,
  recyclerName: recyclerNameKey,
  quantityNos: quantityNosKey,
  productionId: productionIdKey,
  dealerName: dealerNameKey,
  bucketName: bucketNameKey,
  updatedDate: updatedDateKey,
  managementNumber: managementNumberKey,
  inputBatchNumber: inputBatchNumberKey,
  forgedBatchNumber: forgedBatchNumberKey,
  blankingBatchNumber: blankingBatchNumberKey,
  machiningBatchNumber: machiningBatchNumberKey,
  stampingBatchNumber: stampingBatchNumberKey,
  assemblyBatchNumber: assemblyBatchNumberKey,
  paintingBatchNumber: paintingBatchNumberKey,
  partNumber: partNumberKey,
  partName: partNameKey,
  typeOfProduct: typeOfProductKey,
  totalOutputWeightNos: totalOutputWeightNosKey,
  yield: yieldKey,
  dateOfForging: dateOfForgingKey,
  dateOfBlanking: dateOfBlankingKey,
  dateOfMachining: dateOfMachiningKey,
  dateOfStamping: dateOfStampingKey,
  dateOfAssembly: dateOfAssemblyKey,
  dateOfPainting: dateOfPaintingKey,
  polymerType: polymerTypeKey,
  shippedDate: shippedDateKey,
  receptionDate: receptionDateKey,
  productionDate: productionDateKey,
  dateOfReceiptOfVehicle: dateOfReceiptOfVehicleKey,
  modelName: modelNameKey,
  fuelType: fuelTypeKey,
  pcrMaterialCategory: pcrMaterialCategoryKey,
  pcrLotBatchNumber: pcrLotBatchNumberKey,
  pcrCountryOfOrigin: pcrCountryOfOriginKey,
  pcrSupplierType: pcrSupplierTypeKey,
  pcrSupplierName: pcrSupplierNameKey,
  pcrCollectionDate: pcrCollectionDateKey,
  pcrGrossWeightKg: pcrGrossWeightKgKey,
  pcrNetWeightKg: pcrNetWeightKgKey,
  pirMaterialCategory: pirMaterialCategoryKey,
  pirLotBatchNumber: pirLotBatchNumberKey,
  pirGeneratorType: pirGeneratorTypeKey,
  pirGeneratorName: pirGeneratorNameKey,
  pirGenerationDate: pirGenerationDateKey,
} = columnKeys

const pcrJobListColumns = [
  pcrMaterialCategoryKey,
  pcrLotBatchNumberKey,
  pcrCountryOfOriginKey,
  pcrSupplierTypeKey,
  pcrSupplierNameKey,
  pcrCollectionDateKey,
  pcrGrossWeightKgKey,
  pcrNetWeightKgKey,
  statusKey,
]

const pirJobListColumns = [
  jobIdKey,
  pirMaterialCategoryKey,
  pirLotBatchNumberKey,
  pcrCountryOfOriginKey,
  pirGeneratorTypeKey,
  pirGeneratorNameKey,
  pirGenerationDateKey,
  pcrGrossWeightKgKey,
  pcrNetWeightKgKey,
  statusKey,
]

const jobTypeRoleColumns = (materialType, status) => {
  const batchNumber =
    !materialType || isEqual(materialType, 'job_Plastic')
      ? batchNumberKey
      : heatNumberKey
  return {
    [smelting]: {
      [refurbisher]: [
        jobIdKey,
        managementNumberKey,
        heatNumberKey,
        inputInvoiceNumberKey,
        quantityKGKey,
        materialGradeKey,
        CreatedDateKey,
        updatedDateKey,
        statusKey,
      ],
      [producer]: [
        jobIdKey,
        managementNumberKey,
        heatNumberKey,
        inputInvoiceNumberKey,
        quantityKGKey,
        materialGradeKey,
        CreatedDateKey,
        updatedDateKey,
        statusKey,
      ],
    },
    [postProcessing]: {
      [refurbisher]: [
        jobIdKey,
        managementNumberKey,
        heatNumberKey,
        quantityKGKey,
        CreatedDateKey,
        updatedDateKey,
        statusKey,
      ],
      [producer]: [
        jobIdKey,
        managementNumberKey,
        heatNumberKey,
        quantityKGKey,
        CreatedDateKey,
        updatedDateKey,
        statusKey,
      ],
    },
    [recovery]: {
      [recycler]: [
        jobIdKey,
        RVSFVehicleNumberKey,
        RegistrationNumberKey,
        ELVTypeKey,
        SourceKey,
        CategoryKey,
        ...(notEqual(status, tabKeys.active) ? [CreatedDateKey] : []),
        MakerNameKey,
        ...(notEqual(status, tabKeys.active) ? [ActiveDaysKey] : []),
        dateOfReceiptOfVehicleKey,
        modelNameKey,
        fuelTypeKey,
        statusKey,
      ],
      [producer]: [
        jobIdKey,
        RVSFVehicleNumberKey,
        RegistrationNumberKey,
        ELVTypeKey,
        SourceKey,
        CategoryKey,
        ...(notEqual(status, tabKeys.active) ? [CreatedDateKey] : []),
        MakerNameKey,
        ...(notEqual(status, tabKeys.active) ? [ActiveDaysKey] : []),
        dateOfReceiptOfVehicleKey,
        modelNameKey,
        fuelTypeKey,
        statusKey,
      ],
    },
    [elv]: {
      [recycler]: [
        jobIdKey,
        RVSFVehicleNumberKey,
        RegistrationNumberKey,
        ELVTypeKey,
        SourceKey,
        CategoryKey,
        ChassisNumberKey,
        EngineNumberKey,
        RCAvailabilityKey,
        CreatedDateKey,
        MakerNameKey,
        DealerBusinessNameKey,
        CollectionCenterBusinessNameKey,
        ActiveDaysKey,
        dateOfReceiptOfVehicleKey,
        modelNameKey,
        fuelTypeKey,
        statusKey,
      ],
      [producer]: [
        jobIdKey,
        RVSFVehicleNumberKey,
        RegistrationNumberKey,
        ELVTypeKey,
        SourceKey,
        CategoryKey,
        ChassisNumberKey,
        EngineNumberKey,
        RCAvailabilityKey,
        CreatedDateKey,
        MakerNameKey,
        DealerBusinessNameKey,
        CollectionCenterBusinessNameKey,
        ActiveDaysKey,
        dateOfReceiptOfVehicleKey,
        modelNameKey,
        fuelTypeKey,
        statusKey,
      ],
    },
    [testVehicles]: {
      [recycler]: [
        jobIdKey,
        RVSFVehicleNumberKey,
        RegistrationNumberKey,
        ELVTypeKey,
        SourceKey,
        CategoryKey,
        ChassisNumberKey,
        EngineNumberKey,
        RCAvailabilityKey,
        CreatedDateKey,
        MakerNameKey,
        DealerBusinessNameKey,
        CollectionCenterBusinessNameKey,
        ActiveDaysKey,
        dateOfReceiptOfVehicleKey,
        modelNameKey,
        fuelTypeKey,
        statusKey,
      ],
      [producer]: [
        jobIdKey,
        RVSFVehicleNumberKey,
        RegistrationNumberKey,
        ELVTypeKey,
        SourceKey,
        CategoryKey,
        ChassisNumberKey,
        EngineNumberKey,
        RCAvailabilityKey,
        CreatedDateKey,
        MakerNameKey,
        DealerBusinessNameKey,
        CollectionCenterBusinessNameKey,
        ActiveDaysKey,
        dateOfReceiptOfVehicleKey,
        modelNameKey,
        fuelTypeKey,
        statusKey,
      ],
    },
    [pcr]: {
      [recycler]: pcrJobListColumns,
      [producer]: pcrJobListColumns,
    },
    [pir]: {
      [recycler]: pirJobListColumns,
      [producer]: pirJobListColumns,
    },
    [smeltingRequest]: {
      [recycler]: [
        jobIdKey,
        invoiceNumberKey,
        traderInvoiceNumberKey,
        recyclerDispatchToKey,
        bucketNameKey,
        quantityKGKey,
        dispatchDateKey,
        updatedDateKey,
        statusKey,
      ],
      [refurbisher]: [
        jobIdKey,
        invoiceNumberKey,
        traderInvoiceNumberKey,
        sfNameRequestedByKey,
        bucketNameKey,
        quantityKGKey,
        dispatchDateKey,
        updatedDateKey,
        statusKey,
      ],
      [trader]: [
        jobIdKey,
        invoiceNumberKey,
        traderInvoiceNumberKey,
        sfNameRequestedByKey,
        bucketNameKey,
        quantityKGKey,
        dispatchDateKey,
        statusKey,
      ],
      [producer]: [
        jobIdKey,
        invoiceNumberKey,
        traderInvoiceNumberKey,
        recyclerDispatchToKey,
        bucketNameKey,
        quantityKGKey,
        dispatchDateKey,
        updatedDateKey,
        statusKey,
      ],
    },
    [materialReturn]: {
      [refurbisher]: [
        jobIdKey,
        invoiceNumberKey,
        sfNameRequestedByKey,
        bucketNameKey,
        quantityKGKey,
        dispatchDateKey,
        updatedDateKey,
        statusKey,
      ],
      [recycler]: [
        jobIdKey,
        invoiceNumberKey,
        sfNameRequestedByKey,
        bucketNameKey,
        quantityKGKey,
        dispatchDateKey,
        updatedDateKey,
        statusKey,
      ],
      [trader]: [
        jobIdKey,
        invoiceNumberKey,
        sfNameRequestedByKey,
        bucketNameKey,
        quantityKGKey,
        dispatchDateKey,
        updatedDateKey,
        statusKey,
      ],
    },
    [materialSalesMaterialProducer]: {
      [refurbisher]: [
        jobIdKey,
        invoiceNumberKey,
        batchNumber,
        recyclerNameKey,
        quantityKGKey,
        ...(isEqual(materialType, 'job_Plastic') ? [polymerTypeKey] : []),
        materialGradeKey,
        shippedDateKey,
        receptionDateKey,
        statusKey,
      ],
      [producer]: [
        jobIdKey,
        invoiceNumberKey,
        batchNumber,
        recyclerNameKey,
        quantityKGKey,
        ...(isEqual(materialType, 'job_Plastic') ? [polymerTypeKey] : []),
        materialGradeKey,
        shippedDateKey,
        receptionDateKey,
        statusKey,
      ],
    },
    [materialSalesSupplier]: {
      [refurbisher]: [
        jobIdKey,
        invoiceNumberKey,
        batchNumber,
        supplierNameKey,
        quantityKGKey,
        ...(isEqual(materialType, 'job_Plastic') ? [polymerTypeKey] : []),
        materialGradeKey,
        shippedDateKey,
        receptionDateKey,
        statusKey,
      ],
      [supplier]: [
        jobIdKey,
        invoiceNumberKey,
        batchNumber,
        supplierNameKey,
        quantityKGKey,
        ...(isEqual(materialType, 'job_Plastic') ? [polymerTypeKey] : []),
        materialGradeKey,
        shippedDateKey,
        receptionDateKey,
        statusKey,
      ],
      [producer]: [
        jobIdKey,
        invoiceNumberKey,
        batchNumber,
        supplierNameKey,
        quantityKGKey,
        ...(isEqual(materialType, 'job_Plastic') ? [polymerTypeKey] : []),
        materialGradeKey,
        shippedDateKey,
        receptionDateKey,
        statusKey,
      ],
    },
    [partSalesPartProducer]: {
      [supplier]: [
        jobIdKey,
        invoiceNumberKey,
        batchNumberKey,
        partNameKey,
        supplierNameKey,
        quantityKGKey,
        quantityNosKey,
        materialGradeKey,
        shippedDateKey,
        receptionDateKey,
        statusKey,
      ],
      [producer]: [
        jobIdKey,
        invoiceNumberKey,
        batchNumber,
        partNameKey,
        supplierNameKey,
        quantityKGKey,
        quantityNosKey,
        materialGradeKey,
        shippedDateKey,
        receptionDateKey,
        statusKey,
      ],
    },
    [materialSalesProducer]: {
      [supplier]: [
        jobIdKey,
        invoiceNumberKey,
        batchNumberKey,
        OEMNameKey,
        quantityKGKey,
        quantityNosKey,
        partNameKey,
        materialGradeKey,
        shippedDateKey,
        receptionDateKey,
        statusKey,
      ],
      [producer]: [
        jobIdKey,
        invoiceNumberKey,
        batchNumber,
        supplierNameKey,
        quantityKGKey,
        quantityNosKey,
        partNameKey,
        materialGradeKey,
        shippedDateKey,
        receptionDateKey,
        statusKey,
      ],
    },
    [sorting]: {
      [refurbisher]: [
        jobIdKey,
        managementNumberKey,
        inputInvoiceNumberKey,
        outputBatchNumberKey,
        quantityKGKey,
        outputPolymerTypeKey,
        CreatedDateKey,
        updatedDateKey,
        statusKey,
      ],
      [producer]: [
        jobIdKey,
        managementNumberKey,
        inputInvoiceNumberKey,
        outputBatchNumberKey,
        quantityKGKey,
        outputPolymerTypeKey,
        CreatedDateKey,
        updatedDateKey,
        statusKey,
      ],
    },
    [grinding]: {
      [refurbisher]: [
        jobIdKey,
        managementNumberKey,
        inputBatchNumberKey,
        outputBatchNumberKey,
        quantityKGKey,
        polymerTypeKey,
        CreatedDateKey,
        updatedDateKey,
        statusKey,
      ],
      [producer]: [
        jobIdKey,
        managementNumberKey,
        inputBatchNumberKey,
        outputBatchNumberKey,
        quantityKGKey,
        polymerTypeKey,
        CreatedDateKey,
        updatedDateKey,
        statusKey,
      ],
    },
    [pelletizing]: {
      [refurbisher]: [
        jobIdKey,
        managementNumberKey,
        inputBatchNumberKey,
        outputBatchNumberKey,
        quantityKGKey,
        polymerTypeKey,
        materialGradeKey,
        colorKey,
        CreatedDateKey,
        updatedDateKey,
        statusKey,
      ],
      [producer]: [
        jobIdKey,
        managementNumberKey,
        inputBatchNumberKey,
        outputBatchNumberKey,
        quantityKGKey,
        polymerTypeKey,
        materialGradeKey,
        colorKey,
        CreatedDateKey,
        updatedDateKey,
        statusKey,
      ],
    },
    [compoundingPelletizing]: {
      [refurbisher]: [
        jobIdKey,
        managementNumberKey,
        inputBatchNumberKey,
        outputBatchNumberKey,
        quantityKGKey,
        polymerTypeKey,
        materialGradeKey,
        colorKey,
        CreatedDateKey,
        updatedDateKey,
        statusKey,
      ],
      [producer]: [
        jobIdKey,
        managementNumberKey,
        inputBatchNumberKey,
        outputBatchNumberKey,
        quantityKGKey,
        polymerTypeKey,
        materialGradeKey,
        colorKey,
        CreatedDateKey,
        updatedDateKey,
        statusKey,
      ],
    },
    [supplierProduction]: {
      [supplier]: [
        jobIdKey,
        managementNumberKey,
        productionIdKey,
        inputInvoiceNumberKey,
        outputBatchNumberKey,
        quantityKGKey,
        ...(isEqual(materialType, 'job_Plastic') ? [polymerTypeKey] : []),
        materialGradeKey,
        productionDateKey,
        updatedDateKey,
        statusKey,
      ],
      [producer]: [
        jobIdKey,
        managementNumberKey,
        productionIdKey,
        inputInvoiceNumberKey,
        outputBatchNumberKey,
        quantityKGKey,
        ...(isEqual(materialType, 'job_Plastic') ? [polymerTypeKey] : []),
        materialGradeKey,
        productionDateKey,
        updatedDateKey,
        statusKey,
      ],
    },
    [forging]: {
      [supplier]: [
        jobIdKey,
        forgedBatchNumberKey,
        managementNumberKey,
        inputInvoiceNumberKey,
        partNumberKey,
        typeOfProductKey,
        totalOutputWeightNosKey,
        yieldKey,
        statusKey,
        dateOfForgingKey,
      ],
      [producer]: [
        jobIdKey,
        forgedBatchNumberKey,
        managementNumberKey,
        inputInvoiceNumberKey,
        partNumberKey,
        typeOfProductKey,
        totalOutputWeightNosKey,
        yieldKey,
        statusKey,
        dateOfForgingKey,
      ],
    },
    [blanking]: {
      [supplier]: [
        jobIdKey,
        blankingBatchNumberKey,
        managementNumberKey,
        inputInvoiceNumberKey,
        partNumberKey,
        typeOfProductKey,
        totalOutputWeightNosKey,
        yieldKey,
        statusKey,
        dateOfBlankingKey,
      ],
      [producer]: [
        jobIdKey,
        blankingBatchNumberKey,
        managementNumberKey,
        inputInvoiceNumberKey,
        partNumberKey,
        typeOfProductKey,
        totalOutputWeightNosKey,
        yieldKey,
        statusKey,
        dateOfBlankingKey,
      ],
    },
    [machining]: {
      [supplier]: [
        jobIdKey,
        machiningBatchNumberKey,
        managementNumberKey,
        partNumberKey,
        typeOfProductKey,
        totalOutputWeightNosKey,
        yieldKey,
        statusKey,
        dateOfMachiningKey,
      ],
      [producer]: [
        jobIdKey,
        machiningBatchNumberKey,
        managementNumberKey,
        partNumberKey,
        typeOfProductKey,
        totalOutputWeightNosKey,
        yieldKey,
        statusKey,
        dateOfMachiningKey,
      ],
    },
    [stamping]: {
      [supplier]: [
        jobIdKey,
        stampingBatchNumberKey,
        managementNumberKey,
        partNumberKey,
        typeOfProductKey,
        totalOutputWeightNosKey,
        yieldKey,
        statusKey,
        dateOfStampingKey,
      ],
      [producer]: [
        jobIdKey,
        stampingBatchNumberKey,
        managementNumberKey,
        partNumberKey,
        typeOfProductKey,
        totalOutputWeightNosKey,
        yieldKey,
        statusKey,
        dateOfStampingKey,
      ],
    },
    [assembly]: {
      [supplier]: [
        jobIdKey,
        assemblyBatchNumberKey,
        managementNumberKey,
        partNumberKey,
        typeOfProductKey,
        totalOutputWeightNosKey,
        yieldKey,
        statusKey,
        dateOfAssemblyKey,
      ],
      [producer]: [
        jobIdKey,
        assemblyBatchNumberKey,
        managementNumberKey,
        partNumberKey,
        typeOfProductKey,
        totalOutputWeightNosKey,
        yieldKey,
        statusKey,
        dateOfAssemblyKey,
      ],
    },
    [painting]: {
      [supplier]: [
        jobIdKey,
        paintingBatchNumberKey,
        managementNumberKey,
        partNumberKey,
        typeOfProductKey,
        totalOutputWeightNosKey,
        yieldKey,
        statusKey,
        dateOfPaintingKey,
      ],
      [producer]: [
        jobIdKey,
        paintingBatchNumberKey,
        managementNumberKey,
        partNumberKey,
        typeOfProductKey,
        totalOutputWeightNosKey,
        yieldKey,
        statusKey,
        dateOfPaintingKey,
      ],
    },
    [vehicleProduction]: {
      [producer]: [
        jobIdKey,
        managementNumberKey,
        productionIdKey,
        inputInvoiceNumberKey,
        outputBatchNumberKey,
        quantityNosKey,
        productionDateKey,
        updatedDateKey,
        statusKey,
      ],
    },
    [vehicleSales]: {
      [producer]: [
        jobIdKey,
        invoiceNumberKey,
        batchNumber,
        dealerNameKey,
        quantityNosKey,
        shippedDateKey,
        receptionDateKey,
        statusKey,
      ],
    },
  }
}

// Dynamic searchBy configuration similar to jobTypeRoleColumns
const jobTypeRoleSearchBy = (materialType, roleId) => {
  const batchNumberKey =
    !materialType || isEqual(materialType, 'job_Plastic')
      ? { batchNumber }
      : { heatNumber }
  return {
    [smelting]: {
      [refurbisher]: {
        jobId,
        managementNumber,
        ...batchNumberKey,
        inputInvoiceNumber,
        quantityKG,
        materialGrade,
        status,
      },
      [producer]: {
        jobId,
        managementNumber,
        ...batchNumberKey,
        inputInvoiceNumber,
        quantityKG,
        materialGrade,
        status,
      },
    },
    [recovery]: {
      [recycler]: {
        ...(isEqual(roleId, recycler) ? { jobId } : {}),
        recoverySource,
        vehicleType,
        fuelType,
        mstiVehicleNo,
        vehicleRegistrationNo,
        dealerBusinessName,
        makerBusinessName,
        collectionCenterBusinessName,
      },
      [producer]: {
        // jobId,
        recoverySource,
        vehicleType,
        fuelType,
        mstiVehicleNo,
        vehicleRegistrationNo,
        dealerBusinessName,
        makerBusinessName,
        collectionCenterBusinessName,
      },
    },
    [elv]: {
      [recycler]: {
        jobId,
        recoverySource,
        vehicleType,
        fuelType,
        mstiVehicleNo,
        vehicleRegistrationNo,
        rcAvailability,
        chassisNumber,
        engineNumber,
        dealerBusinessName,
        makerBusinessName,
        collectionCenterBusinessName,
      },
      [producer]: {
        jobId,
        recoverySource,
        vehicleType,
        fuelType,
        mstiVehicleNo,
        vehicleRegistrationNo,
        rcAvailability,
        chassisNumber,
        engineNumber,
        dealerBusinessName,
        makerBusinessName,
        collectionCenterBusinessName,
      },
    },
    [testVehicles]: {
      [recycler]: {
        jobId,
        vehicleType,
        fuelType,
        mstiVehicleNo,
        vehicleRegistrationNo,
        rcAvailability,
        chassisNumber,
        engineNumber,
        dealerBusinessName,
        makerBusinessName,
        collectionCenterBusinessName,
      },
      [producer]: {
        jobId,
        vehicleType,
        fuelType,
        mstiVehicleNo,
        vehicleRegistrationNo,
        rcAvailability,
        chassisNumber,
        engineNumber,
        dealerBusinessName,
        makerBusinessName,
        collectionCenterBusinessName,
      },
    },
    [pcr]: {
      [recycler]: {
        pcrMaterialCategory,
        pcrLotBatchNumber,
        pcrPolymerAlloyGrade,
        pcrCountryOfOrigin,
        pcrMaterialForm,
        pcrSupplierName,
        pcrNetWeightKg,
        pcrCollectionDate,
        pcrDateOfIntakeAtFacility,
      },
      [producer]: {
        pcrMaterialCategory,
        pcrLotBatchNumber,
        pcrPolymerAlloyGrade,
        pcrCountryOfOrigin,
        pcrMaterialForm,
        pcrSupplierName,
        pcrNetWeightKg,
        pcrCollectionDate,
        pcrDateOfIntakeAtFacility,
      },
    },
    [pir]: {
      [recycler]: {
        pirMaterialCategory,
        pirLotBatchNumber,
        pirPolymerAlloyGrade,
        pcrCountryOfOrigin,
        pcrMaterialForm,
        pirGeneratorName,
        pcrNetWeightKg,
        pirGenerationDate,
        pirDateOfIntakeAtFacility,
      },
      [producer]: {
        pirMaterialCategory,
        pirLotBatchNumber,
        pirPolymerAlloyGrade,
        pcrCountryOfOrigin,
        pcrMaterialForm,
        pirGeneratorName,
        pcrNetWeightKg,
        pirGenerationDate,
        pirDateOfIntakeAtFacility,
      },
    },
    [postProcessing]: {
      [refurbisher]: {
        jobId,
        managementNumber,
        heatNumber,
        quantityKG,
        status,
      },
      [producer]: {
        jobId,
        managementNumber,
        heatNumber,
        quantityKG,
        status,
      },
    },
    [smeltingRequest]: {
      [recycler]: {
        jobId,
        invoiceNumber,
        tradingCompanyInvoiceNumber,
        recyclerDispatchTo,
        bucketName,
        quantityKG,
        status,
      },
      [refurbisher]: {
        jobId,
        invoiceNumber,
        tradingCompanyInvoiceNumber,
        sfNameRequestedBy,
        quantityKG,
        status,
      },
      [trader]: {
        jobId,
        invoiceNumber,
        tradingCompanyInvoiceNumber,
        sfNameRequestedBy,
        quantityKG,
        status,
      },
      [producer]: {
        jobId,
        invoiceNumber,
        tradingCompanyInvoiceNumber,
        recyclerDispatchTo,
        quantityKG,
        status,
      },
    },
    [materialReturn]: {
      [refurbisher]: {
        jobId,
        invoiceNumber,
        sfNameRequestedBy,
        quantityKG,
        status,
      },
      [recycler]: {
        jobId,
        invoiceNumber,
        sfNameRequestedBy,
        quantityKG,
        status,
      },
      [trader]: {
        jobId,
        invoiceNumber,
        sfNameRequestedBy,
        quantityKG,
        status,
      },
    },
    [materialSalesMaterialProducer]: {
      [refurbisher]: {
        jobId,
        invoiceNumber,
        ...batchNumberKey,
        recyclerName,
        quantityKG,
        ...(isEqual(materialType, 'job_Plastic') ? { polymerType } : {}),
        materialGrade,
        status,
      },
      [producer]: {
        jobId,
        invoiceNumber,
        ...batchNumberKey,
        recyclerName,
        quantityKG,
        ...(isEqual(materialType, 'job_Plastic') ? { polymerType } : {}),
        materialGrade,
        status,
      },
    },
    [materialSalesSupplier]: {
      [refurbisher]: {
        jobId,
        invoiceNumber,
        ...batchNumberKey,
        supplierName,
        quantityKG,
        ...(isEqual(materialType, 'job_Plastic') ? { polymerType } : {}),
        materialGrade,
        status,
      },
      [supplier]: {
        jobId,
        invoiceNumber,
        ...batchNumberKey,
        supplierName,
        quantityKG,
        ...(isEqual(materialType, 'job_Plastic') ? { polymerType } : {}),
        materialGrade,
        status,
      },
      [producer]: {
        jobId,
        invoiceNumber,
        ...batchNumberKey,
        supplierName,
        quantityKG,
        ...(isEqual(materialType, 'job_Plastic') ? { polymerType } : {}),
        materialGrade,
        status,
      },
    },
    [partSalesPartProducer]: {
      [supplier]: {
        jobId,
        invoiceNumber,
        ...batchNumberKey,
        supplierBusinessName,
        quantityKG,
        quantityNos,
        materialGrade,
        status,
      },
      [producer]: {
        jobId,
        invoiceNumber,
        ...batchNumberKey,
        supplierName,
        quantityKG,
        quantityNos,
        materialGrade,
        status,
      },
    },
    [materialSalesProducer]: {
      [supplier]: {
        jobId,
        invoiceNumber,
        ...batchNumberKey,
        OEMName,
        quantityKG,
        quantityNos,
        ...(isEqual(materialType, 'job_Plastic') ? { polymerType } : {}),
        materialGrade,
        status,
      },
      [producer]: {
        jobId,
        invoiceNumber,
        ...batchNumberKey,
        supplierName,
        quantityKG,
        quantityNos,
        ...(isEqual(materialType, 'job_Plastic') ? { polymerType } : {}),
        materialGrade,
        status,
      },
    },
    [sorting]: {
      [refurbisher]: {
        jobId,
        managementNumber,
        inputInvoiceNumber,
        outputBatchNumber,
        quantityKG,
        outputPolymerType,
        status,
      },
      [producer]: {
        jobId,
        managementNumber,
        inputInvoiceNumber,
        outputBatchNumber,
        quantityKG,
        outputPolymerType,
        status,
      },
    },
    [grinding]: {
      [refurbisher]: {
        jobId,
        managementNumber,
        inputBatchNumber,
        outputBatchNumber,
        quantityKG,
        polymerType,
        status,
      },
      [producer]: {
        jobId,
        managementNumber,
        inputBatchNumber,
        outputBatchNumber,
        quantityKG,
        polymerType,
        status,
      },
    },
    [pelletizing]: {
      [refurbisher]: {
        jobId,
        managementNumber,
        inputBatchNumber,
        outputBatchNumber,
        quantityKG,
        polymerType,
        materialGrade,
        color,
        status,
      },
      [producer]: {
        jobId,
        managementNumber,
        inputBatchNumber,
        outputBatchNumber,
        quantityKG,
        polymerType,
        materialGrade,
        color,
        status,
      },
    },
    [compoundingPelletizing]: {
      [refurbisher]: {
        jobId,
        managementNumber,
        inputBatchNumber,
        outputBatchNumber,
        quantityKG,
        polymerType,
        materialGrade,
        color,
        status,
      },
      [producer]: {
        jobId,
        managementNumber,
        inputBatchNumber,
        outputBatchNumber,
        quantityKG,
        polymerType,
        materialGrade,
        color,
        status,
      },
    },
    [supplierProduction]: {
      [supplier]: {
        jobId,
        managementNumber,
        productionId,
        inputInvoiceNumber,
        outputBatchNumber,
        quantityKG,
        ...(isEqual(materialType, 'job_Plastic') ? { polymerType } : {}),
        materialGrade,
        status,
      },
      [producer]: {
        jobId,
        managementNumber,
        productionId,
        inputInvoiceNumber,
        outputBatchNumber,
        quantityKG,
        ...(isEqual(materialType, 'job_Plastic') ? { polymerType } : {}),
        materialGrade,
        status,
      },
    },
    [forging]: {
      [supplier]: {
        jobId,
        forgedBatchNumber,
        managementNumber,
        inputInvoiceNumber,
        typeOfProduct,
        totalOutputWeightNos,
        partNumber,
        status,
      },
      [producer]: {
        jobId,
        forgedBatchNumber,
        managementNumber,
        inputInvoiceNumber,
        typeOfProduct,
        totalOutputWeightNos,
        partNumber,
        status,
      },
    },
    [blanking]: {
      [supplier]: {
        jobId,
        // blankingBatchNumber,
        // managementNumber,
        // inputInvoiceNumber,
        // typeOfProduct,
        // totalOutputWeightNos,
        // partNumber,
        status,
      },
      [producer]: {
        jobId,
        // blankingBatchNumber,
        // managementNumber,
        // inputInvoiceNumber,
        // typeOfProduct,
        // totalOutputWeightNos,
        // partNumber,
        status,
      },
    },
    [machining]: {
      [supplier]: {
        jobId,
        machiningBatchNumber,
        managementNumber,
        typeOfProduct,
        totalOutputWeightNos,
        partNumber,
        status,
      },
      [producer]: {
        jobId,
        machiningBatchNumber,
        managementNumber,
        typeOfProduct,
        totalOutputWeightNos,
        partNumber,
        status,
      },
    },
    [stamping]: {
      [supplier]: {
        jobId,
        stampingBatchNumber,
        managementNumber,
        typeOfProduct,
        totalOutputWeightNos,
        partNumber,
        status,
      },
      [producer]: {
        jobId,
        stampingBatchNumber,
        managementNumber,
        typeOfProduct,
        totalOutputWeightNos,
        partNumber,
        status,
      },
    },
    [assembly]: {
      [supplier]: {
        jobId,
        assemblyBatchNumber,
        managementNumber,
        typeOfProduct,
        totalOutputWeightNos,
        partNumber,
        status,
      },
      [producer]: {
        jobId,
        assemblyBatchNumber,
        managementNumber,
        typeOfProduct,
        totalOutputWeightNos,
        partNumber,
        status,
      },
    },
    [painting]: {
      [supplier]: {
        jobId,
        paintingBatchNumber,
        managementNumber,
        typeOfProduct,
        totalOutputWeightNos,
        partNumber,
        status,
      },
      [producer]: {
        jobId,
        paintingBatchNumber,
        managementNumber,
        typeOfProduct,
        totalOutputWeightNos,
        partNumber,
        status,
      },
    },
    [vehicleProduction]: {
      [producer]: {
        jobId,
        managementNumber,
        productionId,
        inputInvoiceNumber,
        outputBatchNumber,
        quantityNos,
        status,
      },
    },
    [vehicleSales]: {
      [producer]: {
        jobId,
        invoiceNumber,
        ...batchNumberKey,
        dealerName,
        quantityNos,
        status,
      },
    },
  }
}

export const jobStatusList = ({ jobType }) => {
  switch (jobType) {
    case smelting:
      return {
        status: ['JOB_REQUEST_INPROGRESS', 'MATERIAL_PRODUCTION_COMPLETED'],
      }
    case postProcessing:
      return { status: ['POST_PROCESSING_COMPLETED'] }
    case recovery:
      return {
        status: ['JOB_REQUEST_INPROGRESS', 'VEHICLE_COLLECTION_COMPLETED'],
      }
    case elv:
      return {
        status: ['JOB_REQUEST_INPROGRESS', 'VEHICLE_COLLECTION_COMPLETED'],
      }
    case testVehicles:
      return {
        status: ['JOB_REQUEST_INPROGRESS', 'VEHICLE_COLLECTION_COMPLETED'],
      }
    case pcr:
    case pir:
      return {
        status: ['JOB_REQUEST_INPROGRESS', 'VEHICLE_COLLECTION_COMPLETED'],
      }
    case smeltingRequest:
      return {
        status: [
          'DISPATCH (RECYCLE)_REQUESTED',
          '	DISPATCH (RECYCLE)_REQUEST_AWAITING_RECEPTION',
          'DISPATCH_RECYCLE_REQUEST_INPROGRESS',
          'DISPATCH (RECYCLE)_REQUEST_COMPLETED',
        ],
      }
    case materialSalesMaterialProducer:
      return {
        status: [
          'MATERIAL_SALES_MATERIAL_PRODUCER_REQUESTED',
          'MATERIAL_SALES_MATERIAL_PRODUCER_AWAITING_RECEPTION',
          'MATERIAL_SALES_MATERIAL_PRODUCER_COMPLETED',
        ],
      }
    case materialSalesSupplier:
      return {
        status: [
          'MATERIAL_SALES_PART_PRODUCER_REQUESTED',
          'MATERIAL_SALES_PART_PRODUCER_AWAITING_RECEPTION',
          'MATERIAL_SALES_PART_PRODUCER_COMPLETED',
        ],
      }
    case partSalesPartProducer:
      return {
        status: [
          'PART_SALES_PART_PRODUCER_REQUESTED',
          'PART_SALES_PART_PRODUCER_AWAITING_RECEPTION',
          'PART_SALES_PART_PRODUCER_COMPLETED',
        ],
      }
    case materialSalesProducer:
      return {
        status: [
          'PART_SALES_PRODUCER_REQUESTED',
          'PART_SALES_PRODUCER_AWAITING_RECEPTION',
          'PART_SALES_PRODUCER_COMPLETED',
        ],
      }
    case sorting:
      return { status: ['JOB_REQUEST_INPROGRESS', 'SORTING_COMPLETED'] }
    case grinding:
      return { status: ['JOB_REQUEST_INPROGRESS', 'GRINDING_COMPLETED'] }
    case pelletizing:
      return {
        status: [
          'JOB_REQUEST_INPROGRESS',
          'PRE_COMPOUNDING_PELLETIZING_COMPLETED',
        ],
      }
    case compoundingPelletizing:
      return {
        status: ['JOB_REQUEST_INPROGRESS', 'COMPOUNDING_PELLETIZING_COMPLETED'],
      }
    case supplierProduction:
      return { status: ['JOB_REQUEST_INPROGRESS', 'PART_PRODUCTION_COMPLETED'] }
    case forging:
      return { status: ['JOB_REQUEST_INPROGRESS', 'FORGING_COMPLETED'] }
    case blanking:
      return { status: ['JOB_REQUEST_INPROGRESS', 'BLANKING_COMPLETED'] }
    case machining:
      return { status: ['JOB_REQUEST_INPROGRESS', 'MACHINING_COMPLETED'] }
    case stamping:
      return { status: ['JOB_REQUEST_INPROGRESS', 'STAMPING_COMPLETED'] }
    case assembly:
      return { status: ['JOB_REQUEST_INPROGRESS', 'ASSEMBLY_COMPLETED'] }
    case painting:
      return { status: ['JOB_REQUEST_INPROGRESS', 'PAINTING_COMPLETED'] }
    case vehicleProduction:
      return {
        status: ['JOB_REQUEST_INPROGRESS', 'VEHICLE_PRODUCTION_COMPLETED'],
      }
    case vehicleSales:
      return { status: [] }

    default:
      break
  }
}

const getJobType = jobType => {
  return entries(payloadType)?.find(([_, value]) =>
    isEqual(value, jobType),
  )?.[0]
}

const getJobTypeColumnTitles = (jobType, t, materialType = 'job_Steel') => {
  const columnTitlesMap = {
    RECYCLE: [
      'job_SNo',
      'job_InvoiceNoMSTI',
      'job_InvoiceNoTTIPL',
      'job_InvoiceDate',
      'job_QuantityKg',
      'job_BucketName',
    ],
    MATERIAL_PRODUCTION: [
      'job_SNo',
      'job_HeatNo',
      'job_JobCompletionDateHeatCompletionDate',
      'job_InputInvoiceNo',
      'job_InputMSTIScrapQuantityUsedKgs',
      'job_InputVirginQuantityUsedKgs',
      'job_InputVirginSupplierBusinessName',
      'job_InputOtherScrapQuantityUsedKgs',
      'job_InputOtherScrapSupplierBusinessName',
      'job_OutputNumberOfBilletsProduced',
      'job_OutputWeightOfEachBilletKgs',
      'job_TotalOutputWeightKgs',
      'job_OutputTypeOfProduct',
    ],
    POST_PROCESSING: [
      'job_SNo',
      'job_JobCompletionDatePostProcessingCompletionDate',
      'job_InputMaterialProductionHEATID',
      'job_InputQuantityUsedKgs',
      'job_OutputPostProcessingHeatID',
      'job_OutputTotalWeightKgs',
      'job_OutputTypeOfProduct',
    ],
    COMPOUNDING_PELLETIZING: [
      'job_CompletionDate',
      'job_InputSupplierName',
      'job_InputGradeName',
      'job_InputBatchNumber',
      'job_InputQtyReceivedKgs',
      'job_InputVirginMaterialSourceCountry',
      'job_OutputGrade',
      'job_OutputColor',
      'job_OutputBatchNumber',
      'job_FGOutputQtyKgs',
      'job_OutputRecycledMaterial',
      'job_OutputRecycledMaterialQtyInFGKgs',
      'inv_RemainingInInventoryKgs',
    ],
    PRE_COMPOUNDING_PELLETIZING: [
      'job_CompletionDate',
      ...Array.from({ length: 5 }, (_, index) => {
        const serialNumber = index + 1
        return [
          t('job_InputBatchNoNumbered', { batchNo: serialNumber }),
          t('job_InputQuantityUsedKgsNumbered', { quantityNo: serialNumber }),
        ]
      }).flat(),
      'job_QuantityOfOutputProducedKgs',
      'job_PreCompoundingBatchNumber',
      'job_PolymerType',
      'job_Grade',
      'job_Color',
    ],
    MATERIAL_SALES_MATERIAL_PRODUCER: [
      'job_CompletionDate',
      'job_SoldTo',
      'job_BatchNumber',
      'job_InvoiceNumber',
      'job_QuantitySoldKgs',
      'job_BillTo',
    ],
    MATERIAL_SALES_PART_PRODUCER: isEqual(materialType, 'job_Plastic')
      ? [
          'job_CompletionDate',
          'job_SoldTo',
          'job_BatchNumberCompoundingJob',
          'job_QuantitySoldKgs',
          'job_InvoiceNumber',
          'job_TypeOfPolymer',
        ]
      : [
          'job_MaterialHeatNoPostProcessing',
          'job_SoldTo',
          'job_MaterialSalesDate',
          'job_QuantitySoldKgs',
          'job_InvoiceNumber',
        ],
    SORTING: [
      'job_CompletionDate',
      ...Array.from({ length: 5 }, (_, index) => {
        const serialNumber = index + 1
        return [
          t('job_InputInvoiceNoNumbered', { invoiceNo: serialNumber }),
          t('job_InputQuantityUsedKgsNumbered', { quantityNo: serialNumber }),
        ]
      }).flat(),
      ...Array.from({ length: 5 }, (_, index) => {
        const serialNumber = index + 1
        return [
          t('job_OutputPolymerTypeNumbered', { polymerNo: serialNumber }),
          t('job_QuantityOfOutputProducedKgsNumbered', {
            quantityNo: serialNumber,
          }),
          t('job_SortingBatchNumberNumbered', { batchNo: serialNumber }),
          t('job_GradeNumbered', { gradeNo: serialNumber }),
          t('job_ColorNumbered', { colorNo: serialNumber }),
        ]
      }).flat(),
    ],
    GRINDING: [
      'job_CompletionDate',
      ...Array.from({ length: 5 }, (_, index) => {
        const serialNumber = index + 1
        return [
          t('job_SortingBatchNumberNumbered', { batchNo: serialNumber }),
          t('job_InputQuantityUsedKgsNumbered', { quantityNo: serialNumber }),
        ]
      }).flat(),
      'job_QuantityOfOutputProducedKgs',
      'job_GrindingBatchNumber',
      'job_Grade',
      'job_Color',
    ],
    PART_SALES_PART_PRODUCER: [
      'job_CompletionDate',
      'job_SoldTo',
      'inv_BatchId',
      'job_NoOfUnits',
      'job_BillTo',
      'job_InvoiceNumber',
    ],
    PART_PRODUCTION: [
      'job_CompletionDate',
      'job_InvoiceNumber',
      'inv_SupplierName',
      'job_InputQuantityKgs',
      'job_TypeOfProduct',
      'job_QuantityOfOutputProduced',
      'job_WeightOfEachOutputUnit',
      'job_PartNumber',
      'job_Grade',
      'job_Color',
    ],
    MACHINING: [
      'job_CompletionDate',
      'job_ForgedBatchNumber',
      'job_InputQuantityUsedKgs',
      'job_MachiningBatchNumber',
      'job_TypeOfProduct',
      'job_NoOfUnitsProduced',
      'job_TotalOutputWeightKgs',
      'job_WeightOfEachOutputUnit',
      'job_PartNumber',
      'job_RecycledMaterialPercentage',
      'job_Yield',
      'job_ProcessLossPercentage',
    ],
    STAMPING: [
      'job_CompletionDate',
      'job_ForgedBatchNumber',
      'job_InputQuantityUsedKgs',
      'job_StampingBatchNumber',
      'job_TypeOfProduct',
      'job_NoOfUnitsProduced',
      'job_TotalOutputWeightKgs',
      'job_WeightOfEachOutputUnit',
      'job_PartNumber',
      'job_RecycledMaterialPercentage',
      'job_Yield',
      'job_ProcessLossPercentage',
    ],
    PAINTING: [
      'job_CompletionDate',
      'job_StampingBatchNumber',
      'job_InputQuantityUsedKgs',
      'job_PaintingBatchNumber',
      'job_TypeOfProduct',
      'job_NoOfUnitsProduced',
      'job_TotalOutputWeightKgs',
      'job_WeightOfEachOutputUnit',
      'job_PartNumber',
      'job_RecycledMaterialPercentage',
      'job_Yield',
      'job_ProcessLossPercentage',
    ],
  }
  return columnTitlesMap[jobType] || []
}

export const resolveJobListSearchForTab = (
  currentSearchBy,
  previousSearchBy,
  defaultSearchBy,
) => {
  const allowedValues = values(currentSearchBy) ?? []

  if (previousSearchBy != null && include(allowedValues, previousSearchBy)) {
    return { searchBy: previousSearchBy, resetSearchValue: false }
  }
  const searchBy = keyForValue(searchByKeys, defaultSearchBy)
  return { searchBy: searchByKeys?.[searchBy], resetSearchValue: true }
}

export {
  bucketCreationFormSteps,
  categoryELVOptions,
  certTagProp,
  columnKeys,
  destructionRequestSteps,
  dummyJobList,
  dummyRecoveryPeeco,
  dummyRecoveryVardhman,
  getDummyJob,
  jobTypeRoleColumns,
  jobTypeRoleSearchBy,
  hydrometallurgyProcessSteps,
  jobTabList,
  jobWiseReport,
  manualBaleInputFields,
  materialOptions,
  materialSalesMaterialProducerSteps,
  materialSalesProducerFormSteps,
  materialSalesSupplierFormSteps,
  partName,
  partSalesPartProducerSteps,
  payloadType,
  pelletizingJobSteps,
  processFormSteps,
  recoverySteps,
  recycleFormSteps,
  recycleListAttr,
  reuseRequestSteps,
  salesSteps,
  scrapTypePayload,
  searchByKeys,
  searchByLabels,
  pcrSelectSearchByValues,
  pcrDateSearchByValues,
  pirSelectSearchByValues,
  pirDateSearchByValues,
  shareCertificateFields,
  smelterFormSteps,
  sortingJobSteps,
  supplierProductionSteps,
  forgingSteps,
  blankingSteps,
  machiningSteps,
  stampingSteps,
  assemblySteps,
  paintingSteps,
  tabKeys,
  thirdPartyRecycleSteps,
  vehicleProductionSteps,
  vehicleSalesSteps,
  virginMaterialPurchaseSteps,
  getJobType,
  getJobTypeColumnTitles,
}

export const bodyPartsCategories = {
  outerBodyParts: [
    { label: 'txt_Door', value: 'DOOR' },
    { label: 'txt_Hood', value: 'HOOD' },
    { label: 'txt_Dicky', value: 'DICKY' },
    { label: 'txt_Bumper', value: 'BUMPER' },
    { label: 'txt_Fender', value: 'FENDER' },
  ],
  innerBodyParts: [
    { label: 'txt_GearBox', value: 'GEAR_BOX' },
    { label: 'txt_LowerFrame', value: 'LOWER_FRAME' },
    { label: 'txt_DealAxle', value: 'DEAD_AXLE' },
    { label: 'txt_Krank', value: 'KRANK' },
    { label: 'txt_Head', value: 'HEAD' },
    { label: 'txt_SpringShokar', value: 'SPRING_AND_SHOKAR' },
    { label: 'txt_RadiatorFanAssembly', value: 'RADIATOR_FAN_ASSEMBLY' },
    { label: 'txt_SteeringRack', value: 'STEERING_RACK' },
    { label: 'txt_Axel', value: 'AXEL' },
    { label: 'txt_FullSeat', value: 'FULL_SEAT' },
    { label: 'txt_SteelRod', value: 'STEEL_ROD' },
    { label: 'txt_SteeringColumn', value: 'STEERING_COLUMN' },
  ],
}

// All Indian states and union territories for Challan State dropdown
export const INDIAN_STATES = [
  'Andhra Pradesh',
  'Arunachal Pradesh',
  'Assam',
  'Bihar',
  'Chhattisgarh',
  'Goa',
  'Gujarat',
  'Haryana',
  'Himachal Pradesh',
  'Jharkhand',
  'Karnataka',
  'Kerala',
  'Madhya Pradesh',
  'Maharashtra',
  'Manipur',
  'Meghalaya',
  'Mizoram',
  'Nagaland',
  'Odisha',
  'Punjab',
  'Rajasthan',
  'Sikkim',
  'Tamil Nadu',
  'Telangana',
  'Tripura',
  'Uttarakhand',
  'Uttar Pradesh',
  'West Bengal',
  'Andaman and Nicobar Islands',
  'Chandigarh',
  'Dadra and Nagar Haveli and Daman and Diu',
  'Delhi',
  'Jammu and Kashmir',
  'Ladakh',
  'Lakshadweep',
  'Puducherry',
].map((name, index) => ({ id: index + 1, key: name, name }))

export const getParentRole = roleId => {
  switch (roleId) {
    case scrappingFacilityManager:
    case superUser:
    case scrappingFacilityEntryUser:
    case dataEntry:
    case categoryUser:
    case salesUser:
    case operationsUser:
    case recycler:
      return recycler
    case refurbisher:
    case refurbisherUser:
    case procurement:
    case operations:
    case salesUserParent:
      return refurbisher
    case trader:
    case traderUser:
      return trader
    case producer:
    case producerUser:
      return producer
    case consumer:
    case consumerUser:
      return consumer
    case supplier:
    case supplierUser:
      return supplier
    case dealer:
    case dealerUser:
      return dealer

    default:
      return 0
  }
}
